import React, { Suspense, lazy, useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Box,
  Button,
  TextField,
  Grid as Grid2,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  useTheme,
  CircularProgress,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  IconButton,
  Paper,
  Skeleton,
  Alert,
} from "@mui/material";
import {
  useCreateAndUpdateProductMutation,
  useLazyGetProductDetailsQuery,
  useLazyCheckProductFieldIsDuplicateOrNotQuery,
  useLazyCheckCountryMappingQuery,
  useUploadMultipleFilesMutation,
  useDeleteSingleFileMutation,
  useBulkDiscountPreviewMutation,
} from "../../../../Services/ProductService";
import DiscountImpactTable from "../../../../Components/DiscountImpactTable";
import { useDispatch, useSelector } from "react-redux";
import { showSnackbar } from "../../../../Redux/Slices/NotificationSlice";
import FileUploader from "../../../../Components/FileUploader";
import { useBlocker, useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../../../../Components/BreadCrumb";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { alpha } from "@mui/material/styles";
import "./AddProduct.scss";
import { FiUpload, FiSearch as SearchIcon } from "react-icons/fi";
import {
  useGetCategoryListQuery,
  useLazyGetCategoryListQuery,
  useLazySearchCategoryQuery,
  useLazyGetAllFilterCategoryListQuery,
} from "../../../../Services/CategoryService";
import InputAdornment from "@mui/material/InputAdornment";
import {
  useLazySupplierSearchQuery,
  useLazyGetSupplierDetailsQuery,
} from "../../../../Services/SupplierService";
import {
  useLazyGetAllCountryQuery,
  useLazyGetCountryDialingListQuery,
  useLazySearchCountryQuery,
} from "../../../../Services/CountryService";
import { useLazyGetTaxProfilesQuery } from "../../../../Services/Taxation";
import Autocomplete from "@mui/material/Autocomplete";
import Utils from "../../../../Helpers/Utils";
import Chip from "@mui/material/Chip";
import Types from "../../../../Helpers/Interfaces/ProductsType";
import {
  ProductFormInputs,
  CountryNewModel,
  CategoryFormModel,
} from "../../../../Helpers/Interfaces/ProductFormType";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { FaTrash } from "react-icons/fa6";
import { useConfirmation } from "../../../../Components/ConfirmationDialog";
import { FaPencil } from "react-icons/fa6";
import { FaCheckCircle } from "react-icons/fa";
import { MdPreview } from "react-icons/md";
import {
  apiExecutionOptions,
  priceTypeOptions,
  productTypeOptions,
  getDate,
} from "./PConstant";
import { TaxationFilterType } from "../../../../Helpers/Interfaces/FilterType";
const ImageGallery = lazy(() => import("./ImageGallery"));

const stockOptions = [
  { value: "true", label: "In stock" },
  { value: "false", label: "Out of stock" },
];

const statusOptions = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "InActive" },
];
const denominationStatusOptions = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "InActive" },
];

const defaultValues: ProductFormInputs = {
  productName: "",
  shortDescription: "",
  fullDescription: "",
  price: "",
  categoryId: [],
  productImage: null,
  productGallery: [],
  imageGallery: [],
  isProductManually: false,
  productStatus: "active",
  // inStock: "true",
  titleTag: "",
  metaDescription: "",
  productURL: "",
  terms: "",
  termsLink: "",
  instructions: "",
  priceType: "fixed",
  redeemable: "both",
  isPopular: false,
  isFeatured: false,
  isPaysafe: false,
  productDenominations: [
    {
      productDenominationsku: "",
      denomination: 0,
      denominationDescription: "",
      minValue: 0,
      maxValue: 0,
      denominationStatus: "active",
      type: "fixed",
      discount: {
        onlinePayment: 0,
        bankTransfer: 0,
      },
    },
  ],
  countryIsoCodes: [],
  topUpCountryIsoCodes: [],
  productsku: "",
  eanNumber: "",
  productType: "cards",
  pinLength: 0,
  pinQr: "",
  maxOrderQty: 0,
  apiExecution: "priority",
  maxOrderQuantity: 0,
  minOrderQuantity: 0,
  isCustomMapping: true,
  isInclusiveOfTax: true,
  taxProfileId: "",
  // Discount configuration
  discountType: "percentage",
  discountApplyTo: "per-denomination",
  productLevelDiscount: {
    onlinePayment: 0,
    bankTransfer: 0,
  },
};

const AddProduct = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = useState<any>("");
  const [categoryError, setCategoryError] = useState<any>("");
  const [fullDescriptionError, setfullDescriptionError] = useState<any>("");
  const [countryIsoError, setCountryIsoError] = useState<any>("");
  const [taxCoverageError, setTaxCoverageError] = useState<string>("");
  const [galleryFiles, setGalleryFiles] = React.useState<any[]>([]);
  const [isUploading, setIsUploading] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState<{
    symbol: string;
    allValidCurrencies: boolean;
  }>({ symbol: "€", allValidCurrencies: true });
  const countriesDialingData: any = useSelector(
    (state: any) => state.SettingSlice.countryDialingList,
  );
  const [
    triggerGetAllFilterCategoryList,
    { data: categoryList, isFetching, error },
  ] = useLazyGetAllFilterCategoryListQuery();
  // const categoryList: any = useSelector(
  //   (state: any) => state.SettingSlice.categoryList
  // );
  // const taxData: any = useSelector((state: any) => state.AuthSlice.taxData);

  const theme = useTheme();

  // let _categoryList: any = [];
  const [triggerGetCategoryList] = useLazyGetCategoryListQuery();
  const [tiggerProductDetails, { data: getProductData }] =
    useLazyGetProductDetailsQuery();
  const [createAndUpdateProduct, { isLoading }] =
    useCreateAndUpdateProductMutation();
  const [getAllCountryTrigger] = useLazyGetCountryDialingListQuery();
  const [
    checkProductFieldIsDuplicateOrNotTrigger,
    { isLoading: isCheckingDuplicate },
  ] = useLazyCheckProductFieldIsDuplicateOrNotQuery();
  const [checkCountryMappingTrigger] = useLazyCheckCountryMappingQuery();
  // const [getAllCountryTrigger, { data: countriesDialingData }] = useLazyGetCountryDialingListQuery();
  // const [searchSupplierTrigger, { data: supplierData, isLoading: isSupplierLoading }] = useLazySupplierSearchQuery();
  const [getSupplierDetailsTrigger] = useLazyGetSupplierDetailsQuery();
  const [triggerGetTaxProfiles, { data: taxData, isFetching: isTaxFetching }] =
    useLazyGetTaxProfilesQuery();
  const [taxProfiles, setTaxProfiles] = useState<any[]>([]);
  const [taxPage, setTaxPage] = useState(1);
  const [hasMoreTaxProfiles, setHasMoreTaxProfiles] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const taxProfilesRef = useRef<HTMLDivElement>(null);
  const [taxSearch, setTaxSearch] = useState("");
  const taxMenuRef = useRef<HTMLDivElement>(null);
  const fullDescriptionQuillRef = useRef<any>(null);
  const termsQuillRef = useRef<any>(null);
  const instructionsQuillRef = useRef<any>(null);

  const [selectedDenominationValue, setSelectedDenominationValue] =
    useState<string>("active");
  const [selectedOwnPriceTypeValue, setSelectedOwnPriceTypeValue] =
    useState<string>("fixed");
  const [range, setRange] = useState<{ minValue: number; maxValue: number }>({
    minValue: 0,
    maxValue: 0,
  });
  const [denominationDiscount, setDenominationDiscount] = useState<{
    discountType: 'percentage' | 'flat';
    onlinePayment: number | string;
    bankTransfer: number | string;
  }>({
    discountType: 'percentage',
    onlinePayment: '',
    bankTransfer: '',
  });
  const [impactData, setImpactData] = useState<any>(null);
  const [isImpactVisible, setIsImpactVisible] = useState(false);
  const [bulkPreview, { isLoading: isImpactLoading }] = useBulkDiscountPreviewMutation();
  const [taxationProfile, setTaxationProfile] = useState<string>("");

  const useInfo = useSelector((state: any) => state.AuthSlice.adminAuthUser);
  // const searchedName = useRef<string>("");
  const [searchCategoryTrigger, { data: searchCategoryData }] =
    useLazySearchCategoryQuery();
  // const [searchCountryTrigger, { data: countriesDialingData }] = useLazySearchCountryQuery();

  const handleDenominationValueChange = (event: any) => {
    setSelectedDenominationValue(event.target.value as string);
  };

  // const [countryAllList, setCountryAllList] = useState<any>({ input: "", data: [] });
  // const [categoryAllList, setCategoryAllList] = useState<any>([]);
  const [multiplePriceTempData, setMultiplePriceTempData] = useState<any>({
    index: -1,
  });
  const [isFormReady, setIsFormReady] = useState<boolean>(false);
  const [isDuplicateIssue, setIsDuplicateIssue] = useState<boolean>(false);
  const { requestConfirmation } = useConfirmation();

  const [filters, setFilters] = useState<TaxationFilterType>({
    status: "All",
    page: 1,
    rowsPerPage: 10,
    sortBy: "",
    sortDirection: "desc",
    search: "",
  });

  useEffect(() => {
    getTaxList();
  }, [filters]);

  // Every product is taxed: it either names a profile or inherits the system
  // default. With no default in place nothing resolves, the rate falls to 0,
  // and the product sells untaxed with no error anywhere. Block it here so an
  // admin finds out before filling in the form, not from a save failure.
  const hasLoadedTaxProfiles = Array.isArray(taxData?.data);
  const noDefaultTaxProfile =
    hasLoadedTaxProfiles &&
    !(taxData?.data || []).some((item: any) => item.isDefault);

  useEffect(() => {
    if (taxData?.data && !id) {
      const defaultTaxId = taxData?.data?.find(
        (item: any) => item.isDefault,
      )?._id;

      if (defaultTaxId) {
        setValue("taxProfileId", defaultTaxId);
      }
    }
  }, [taxData?.data, id]);

  const getTaxList = () => {
    const params: any = {
      page: filters.page,
      pageSize: filters.rowsPerPage,
      search: filters.search || "",
      // filters: [{ key: "isActive", value: filters.status === "Archive" }],
      sortBy: filters.sortBy || "createdAt",
      sortOrder: filters.sortDirection || "desc",
    };

    if (
      filters.status &&
      filters.status !== "Archive" &&
      filters.status !== "All"
    ) {
      params.filters.push({
        key: "productStatus",
        value: filters.status === "Active" ? "active" : "inactive",
      });
    }

    triggerGetTaxProfiles(params); // API call
  };

  // Handle tax profiles scroll
  const handleTaxProfilesScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    const isNearBottom = scrollTop + clientHeight >= scrollHeight - 20;

    if (
      isNearBottom &&
      hasMoreTaxProfiles &&
      !isLoadingMore &&
      !isTaxFetching
    ) {
      loadMoreTaxProfiles();
    }
  };

  // Load more tax profiles
  const loadMoreTaxProfiles = async () => {
    if (isLoadingMore || !hasMoreTaxProfiles) return;

    setIsLoadingMore(true);
    const nextPage = taxPage + 1;

    try {
      const params = {
        page: nextPage,
        pageSize: 10,
        filters: [],
        sortBy: "createdAt",
        sortOrder: "desc",
        search: taxSearch,
      };

      const result = await triggerGetTaxProfiles(params, false);

      if (result.data) {
        setTaxProfiles((prev) => [...prev, ...(result.data?.data || [])]);
        setTaxPage(nextPage);
        setHasMoreTaxProfiles(nextPage < (result.data?.totalPages || 0));
      }
    } catch (error) {
    } finally {
      setIsLoadingMore(false);
    }
  };

  /**
   * Reload the tax profile list from the first page.
   *
   * A product cannot be saved without a tax profile, so somebody part-way
   * through creating one often goes and adds the profile they need. Coming
   * back, the dropdown still held the list fetched when the form mounted --
   * the new profile was simply absent, with nothing to say why, and the only
   * way out was reloading the whole page and losing the form.
   */
  const reloadTaxProfiles = useCallback(() => {
    return triggerGetTaxProfiles({
      page: 1,
      pageSize: 10,
      filters: [],
      sortBy: "createdAt",
      sortOrder: "desc",
      search: taxSearch,
    }).then((result: any) => {
      if (result.data) {
        setTaxProfiles(result.data.data || []);
        setTaxPage(1);
        setHasMoreTaxProfiles(1 < (result.data.totalPages || 0));
      }
    });
  }, [taxSearch, triggerGetTaxProfiles]);

  // Fetch tax profiles on component mount or search change
  useEffect(() => {
    reloadTaxProfiles();
  }, [taxSearch]);

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    setError,
    clearErrors,
    register,
    getValues,
    trigger,
    formState: { errors, isDirty },
  } = useForm<ProductFormInputs>({
    defaultValues,
    mode: "onChange",
    resolver: (values) => {
      const errors: any = {};

      // Validate based on price type
      if (!values.productDenominations?.length) {
        errors.productDenominations = {
          type: "required",
          message: "At least one denomination is required",
        };
      }

      // Product name validation
      if (!values.productName) {
        errors.productName = {
          type: "required",
          message: "Product name is required",
        };
      } else if (values.productName.length < 3) {
        errors.productName = {
          type: "minLength",
          message: "Product name must be at least 3 characters",
        };
      } else if (values.productName.length > 100) {
        errors.productName = {
          type: "maxLength",
          message: "Product name cannot exceed 100 characters",
        };
      }

      // SKU validation
      if (!values.productsku) {
        errors.productsku = {
          type: "required",
          message: "SKU is required",
        };
      } else if (values.productsku.length < 3) {
        errors.productsku = {
          type: "minLength",
          message: "SKU must be at least 3 characters",
        };
      } else if (values.productsku.length > 50) {
        errors.productsku = {
          type: "maxLength",
          message: "SKU cannot exceed 50 characters",
        };
      } else if (!/^[A-Za-z0-9-_ ]+$/.test(values.productsku)) {
        errors.productsku = {
          type: "pattern",
          message:
            "SKU can only contain letters, numbers, hyphens, and underscores",
        };
      }

      // EAN validation
      if (!values.eanNumber) {
        errors.eanNumber = {
          type: "required",
          message: "EAN Number is required",
        };
      } else {
        const trimmedEan = values.eanNumber.trim();
        const isValidEan =
          /^\d{8}$/.test(trimmedEan) ||
          /^\d{13}$/.test(trimmedEan) ||
          /^\d{14}$/.test(trimmedEan);

        if (!isValidEan) {
          errors.eanNumber = {
            type: "validate",
            message: "EAN Number must be 8, 13, or 14 digits",
          };
        }
      }

      // Short description validation
      if (!values.shortDescription) {
        errors.shortDescription = {
          type: "required",
          message: "Description is required",
        };
      }
      if (!values.fullDescription || values.fullDescription === "<p><br></p>") {
        errors.fullDescription = {
          type: "required",
          message: "Descriptions is required",
        };
      }
      // if (!values.supplierId) {
      //   errors.supplierId = {
      //     type: 'required',
      //     message: 'Supplier is required'
      //   };
      // }
      if (!values.categoryId) {
        errors.categoryId = {
          type: "required",
          message: "Category is required",
        };
      }
      if (!values.productImage) {
        errors.productImage = {
          type: "required",
          message: "Product Image is required",
        };
      }
      if (!values.productStatus) {
        errors.productStatus = {
          type: "required",
          message: "Status is required",
        };
      }
      // if (!values.inStock) {
      //   errors.inStock = {
      //     type: "required",
      //     message: "Stock Status is required",
      //   };
      // }

      if (values.maxOrderQty === null || values.maxOrderQty === undefined) {
        errors.maxOrderQty = {
          type: "required",
          message: "Max Order Quantity is required",
        };
      } else if (values.maxOrderQty <= 0) {
        errors.maxOrderQty = {
          type: "validate",
          message: "Max Order Quantity should be greater than 0",
        };
      }

      /*
       * Pin length applies to phone refills too, not only gift cards.
       *
       * A phone refill is not always a live top-up. It is often a scratch
       * card: the customer gets a PIN and the instructions for redeeming it.
       * Eight phone-refill products already carry PIN stock -- Lebara alone
       * has 16 pins across real orders -- and every one of them has a proper
       * length set.
       *
       * The route is chosen per ORDER, not per product:
       *     productType === Cards || (productType === PhoneRefil && !accountNumber)
       * so ANY phone refill delivers a PIN when the customer gives no number.
       * A product created for top-up only can therefore need a pin length
       * later, and "VI sim" was saved with 0 because this check skipped it.
       *
       * Getting it wrong this way costs a meaningless 8 on a pure top-up
       * product. Getting it wrong the other way is silent: the PIN file
       * import refuses with "pinLength is required" and nobody connects that
       * to a product created weeks earlier.
       */
      if (
        values.productType === "cards" ||
        values.productType === "phone-refill"
      ) {
        if (values.pinLength === null || values.pinLength === undefined) {
          errors.pinLength = {
            type: "required",
            message: "Pin length is required",
          };
        } else if (values.pinLength < 5 || values.pinLength > 25) {
          errors.pinLength = {
            type: "validate",
            message: "Pin length should be between 5 and 25",
          };
        }
      }

      if (!values.terms) {
        errors.terms = {
          type: "required",
          message: "Terms and conditions is required",
        };
      }
      if (!values.instructions) {
        errors.instructions = {
          type: "required",
          message: "Redemption instructions are required",
        };
      }

      return {
        values,
        errors,
      };
    },
  });

  const productType = watch("productType");

  useEffect(() => {
    if (id && !useInfo?.permissions?.products?.edit) {
      navigate(-1);
    }

    const lastFetch = localStorage.getItem("lastCountryFetch");
    const now = getDate;
    const lastFetchDate = lastFetch ? new Date(lastFetch) : null;

    const isMoreThanOneDay =
      !lastFetchDate ||
      now.getTime() - lastFetchDate.getTime() > 24 * 60 * 60 * 1000;

    if (isMoreThanOneDay || countriesDialingData?.length === 0) {
      // console.log(
      //   isMoreThanOneDay,
      //   "isMoreThanOneDay",
      //   getDate,
      //   countriesDialingData?.length
      // );
      const timeout = setTimeout(() => {
        getAllCountryTrigger();
        localStorage.setItem("lastCountryFetch", getDate.toString());
      }, 1500);

      return () => clearTimeout(timeout);
    }
  }, [countriesDialingData]);

  useEffect(() => {
    if (!productType) return;

    // setValue("categoryId", []);

    // decide filters based on productType
    let filters: { key: string; value: any }[] = [
      { key: "isDelete", value: false },
      { key: "isActive", value: true },
    ];

    if (productType === "cards") {
      filters.push({
        key: "parentCategoryName",
        value: ["Gift Cards", "Gaming"],
      });
    } else if (productType === "phone-refill") {
      /*
        Both refill parents.

        International top-ups are productType "phone-refill" -- they differ by
        parent category, not by type. Filtering on "Phone Refill" alone hid
        their own category from the dropdown, so the 16 products already in it
        showed an editing form that did not contain the category they were in,
        and saving could quietly drop it.
      */
      filters.push({
        key: "parentCategoryName",
        value: ["Phone Refill", "International Top Up"],
      });
    }

    triggerGetAllFilterCategoryList({ filters });
  }, [productType, triggerGetAllFilterCategoryList]);

  // useEffect(() => {
  //   const lastFetch = localStorage.getItem("lastCategoryFetch");
  //   const now = getDate;
  //   const lastFetchDate = lastFetch ? new Date(lastFetch) : null;

  //   const isMoreThanOneDay =
  //     !lastFetchDate ||
  //     now.getTime() - lastFetchDate.getTime() > 24 * 60 * 60 * 1000;

  //   if (isMoreThanOneDay || categoryList?.length === 0) {
  //     const timeout = setTimeout(() => {
  //       triggerGetCategoryList();
  //       localStorage.setItem("lastCategoryFetch", getDate.toString());
  //     }, 1500);

  //     return () => clearTimeout(timeout);
  //   }
  // }, [categoryList]);

  useEffect(() => {
    if (id) {
      tiggerProductDetails(id);
    }
  }, [id]);

  useEffect(() => {
    if (getProductData && getProductData?._id) {
      setValue("productName", getProductData.productName);
      setValue("shortDescription", getProductData.shortDescription);
      setValue("fullDescription", getProductData.fullDescription);
      setValue("price", getProductData.price);
      // Only set category IDs that are active and present in the category list
      const activeCategoryIds = getProductData.categoryId
        .filter((item: any) => item.isActive !== false)
        .map((item: any) => item._id);
      setValue("categoryId", activeCategoryIds);
      if (activeCategoryIds.length === 0 && getProductData.categoryId.length > 0) {
        setCategoryError("The assigned category is inactive. Please select an active category.");
      }
      setValue("productImage", getProductData.productImage);
      setValue("productGallery", getProductData.productGallery);
      setValue("productStatus", getProductData.productStatus || "active");
      // setValue("inStock", getProductData.inStock);
      // setValue('quantity', getProductData.quantity);
      setValue("titleTag", getProductData.titleTag);
      setValue("metaDescription", getProductData.metaDescription);
      setValue("productURL", getProductData.productURL);
      setValue("terms", getProductData.terms);
      setValue("termsLink", getProductData.termsLink);
      setValue("instructions", getProductData.instructions);
      setValue("priceType", getProductData.priceType);
      setValue(
        "productDenominations",
        getProductData?.productDenominations &&
          getProductData?.productDenominations?.length > 0
          ? getProductData.productDenominations
          : [],
      );
      setValue("countryIsoCodes", getProductData.countryIsoCodes);
      /*
       * The destination, read back when editing.
       *
       * Without this the field sat empty on every edit, so anybody saving an
       * unrelated change would have wiped the destination for that product --
       * the form would have submitted the empty value it was showing.
       */
      setValue(
        "topUpCountryIsoCodes",
        getProductData.topUpCountryIsoCodes || [],
      );
      setValue("productsku", getProductData.productsku);
      setValue("pinLength", getProductData.pinLength);
      setValue("pinQr", getProductData.pinQr);
      setValue("eanNumber", getProductData.eanNumber);
      setValue("isProductManually", getProductData.isProductManually);
      setValue("maxOrderQty", getProductData.maxOrderQty || 0);
      // setValue('supplierId', getProductData.supplierId);
      setValue("productType", getProductData.productType || "cards");
      setValue("isPopular", getProductData.isPopular || false);
      setValue("isFeatured", getProductData.isFeatured || false);
      setValue("isPaysafe", getProductData.isPaysafe || false);
      setValue("isCustomMapping", getProductData.isCustomMapping);
      setValue("redeemable", getProductData.redeemable || "online");
      setValue("apiExecution", getProductData.apiExecution || "priority");
      setValue("isInclusiveOfTax", getProductData.isInclusiveOfTax || false);
      // A product with no profile is still taxed -- it inherits the system
      // default -- so show that profile rather than leaving the field blank.
      // Leaving it empty made the applied taxation impossible to identify, and
      // it affects 101 of 177 products. Saving then makes the choice explicit.
      setValue(
        "taxProfileId",
        getProductData.taxProfileId ||
          taxData?.data?.find((item: any) => item.isDefault)?._id ||
          "",
      );
      // getSupplierDetailsTrigger(getProductData.supplierId).unwrap()
      //   .then((response) => {
      //     setSelectedSupplier(response);
      //   });
      // Discount configuration
      // Map DB values to form values
      const dbDiscountApplyTo = getProductData.discountApplyTo;
      if (dbDiscountApplyTo === 'product') {
        setValue("discountApplyTo", "entire-product");
      } else if (dbDiscountApplyTo === 'denomination') {
        setValue("discountApplyTo", "per-denomination");
      }

      const dbDiscountType = getProductData.discountType;
      if (dbDiscountType === 'flat') {
        setValue("discountType", "fixed");
      } else if (dbDiscountType === 'percentage') {
        setValue("discountType", "percentage");
      }

      if (getProductData.productDiscount) {
        setValue("productLevelDiscount", {
          onlinePayment: getProductData.productDiscount.onlinePayment || 0,
          bankTransfer: getProductData.productDiscount.bankTransfer || 0,
        });
      }

      setGalleryFiles(getProductData.productGallery);
      // setCountryAllList({ input: '', data: getProductData.countriesList || [] })
      checkAllCountryHaveSameCurrency(getProductData.countryIsoCodes);
    }
  }, [getProductData]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      setIsFormReady(true);
    }, 2000);
    return () => clearTimeout(timeout);
  }, []);

  // useEffect(() => {
  //   if (getProductData?.supplierId) {
  //     getSupplierDetailsTrigger(getProductData.supplierId).unwrap()
  //       .then((response: any) => {
  //         if(response){
  //           setSelectedSupplier(response);
  //           setValue('supplierId', response?._id);
  //         }
  //       });
  //   }
  // }, [getProductData]);

  /**
   * Returns the problems found, so the caller can SAY what they are.
   *
   * It used to return a bare boolean and onSubmit did `if (!isValid) return;`
   * -- a submit that stops dead with nothing said. Each branch sets its own
   * inline error, which covers the ones on screen, except that
   * fullDescriptionError was set and never rendered anywhere. An empty
   * description therefore blocked the save with no request, no message and
   * nothing in the console. Reported as "I am clicking create product,
   * nothing happens".
   */
  const checkManualyDenomination = (isScrollToError: boolean = false) => {
    const categoryId = getValues("categoryId");
    let countError: number = 0;
    const problems: string[] = [];
    if (categoryId.length === 0) {
      if (isScrollToError) {
        document.querySelector("#categoryId")?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      setCategoryError("Please select at least one category");
      problems.push("Category");
      countError++;
    } else {
      setCategoryError("");
    }
    const fullDescription = getValues("fullDescription");

    if (!fullDescription || fullDescription.trim() === "") {
      if (isScrollToError) {
        document.querySelector("#fullDescription")?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      setfullDescriptionError("full Descriptions is required");
      problems.push("Full description");
      countError++;
    } else {
      setfullDescriptionError("");
    }
    const countryIsoCodes = getValues("countryIsoCodes");

    if (countryIsoCodes.length === 0) {
      if (isScrollToError) {
        document.querySelector("#countryIsoCodes")?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      setCountryIsoError("Please select at least one country");
      problems.push("Country");
      countError++;
    } else {
      setCountryIsoError("");
    }

    // The selected Tax Profile must have a rate configured for every
    // selected country — otherwise this product would silently compute 0%
    // tax for whichever countries aren't covered (mirrors the backend check
    // in controllers/product.ts).
    const taxProfileId = getValues("taxProfileId");
    if (taxProfileId && countryIsoCodes.length > 0) {
      const selectedProfile = taxProfiles.find(
        (p: any) => p._id === taxProfileId,
      );
      if (selectedProfile) {
        const coveredCountries = new Set(
          (selectedProfile.taxProfiles || []).map(
            (t: any) => t.countryCode,
          ),
        );
        const missingCountries = countryIsoCodes.filter(
          (code: string) => !coveredCountries.has(code),
        );
        if (missingCountries.length > 0) {
          if (isScrollToError) {
            document.querySelector("#taxProfileId")?.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
          setTaxCoverageError(
            `Tax profile "${selectedProfile.profileName}" has no tax rate configured for: ${missingCountries.join(
              ", ",
            )}. Please add a rate for ${
              missingCountries.length > 1 ? "these countries" : "this country"
            } in the Taxation module, or select a different tax profile.`,
          );
          countError++;
          problems.push("Tax profile coverage");
        } else {
          setTaxCoverageError("");
        }
      }
    } else {
      setTaxCoverageError("");
    }

    // Get and sanitize denominations
    let productDenominations = getValues("productDenominations") || [];

    // Filter out empty/default entries
    productDenominations = productDenominations.filter((item) => {
      return (
        item.productDenominationsku?.trim() !== "" ||
        item.denomination !== 0 ||
        item.denominationDescription?.trim() !== "" ||
        item.minValue !== 0 ||
        item.maxValue !== 0
      );
    });

    // If still empty after filtering
    if (productDenominations.length === 0) {
      setErrorMsg("Please add at least one denomination");
      problems.push("At least one denomination");
      countError++;
    } else {
      setErrorMsg("");
    }

    return problems;
  };

  /**
   * Say what is missing when the form refuses to submit.
   *
   * handleSubmit takes a second callback for the invalid case and it had
   * none, so a failed validation did LITERALLY nothing: onSubmit never ran,
   * no request went out, no message appeared. Several required fields --
   * terms, redemption instructions, pin length, product image -- sit well
   * below the fold, so their helper text was off screen and the button
   * looked dead. Reported as "I am clicking create product, nothing
   * happens", which is precisely what it did.
   *
   * Names what is missing and scrolls to the first one, so the answer is on
   * screen instead of somewhere down the page.
   */
  const FIELD_LABELS: Record<string, string> = {
    productName: "Product name",
    productsku: "SKU",
    eanNumber: "EAN number",
    shortDescription: "Short description",
    fullDescription: "Full description",
    categoryId: "Category",
    productImage: "Product image",
    productStatus: "Status",
    maxOrderQty: "Max order quantity",
    pinLength: "Pin length",
    terms: "Terms and conditions",
    instructions: "Redemption instructions",
    countryIsoCodes: "Country",
    currencyIso: "Currency",
    taxProfileId: "Tax profile",
  };

  const onInvalid = (formErrors: any) => {
    const names = Object.keys(formErrors || {});
    if (!names.length) return;

    const labels = names.map((n) => FIELD_LABELS[n] || n);
    dispatch(
      showSnackbar({
        message:
          labels.length === 1
            ? `${labels[0]} is required or invalid.`
            : `Please complete: ${labels.slice(0, 4).join(", ")}${
                labels.length > 4 ? ` and ${labels.length - 4} more` : ""
              }.`,
        severity: "error",
      }),
    );

    // Bring the first problem into view; it is usually the one off screen.
    const first = names[0];
    const el =
      document.querySelector(`[name="${first}"]`) ||
      document.getElementById(first);
    if (el && typeof (el as any).scrollIntoView === "function") {
      (el as any).scrollIntoView({ behavior: "smooth", block: "center" });
      if (typeof (el as any).focus === "function") {
        setTimeout(() => (el as any).focus({ preventScroll: true }), 400);
      }
    }
  };

  const onSubmit = async (data: ProductFormInputs) => {
    if (noDefaultTaxProfile) {
      dispatch(
        showSnackbar({
          message:
            "No default tax profile exists, so this product could not be taxed. Create a tax profile and mark it as the default first.",
          severity: "error",
        }),
      );
      return;
    }
    if (isDuplicateIssue) {
      dispatch(
        showSnackbar({
          message:
            "Some field value is duplicate, Please enter a different value",
          severity: "error",
        }),
      );
      return;
    }
    const problems = checkManualyDenomination(true);
    if (problems.length) {
      // Never stop a submit without saying why.
      dispatch(
        showSnackbar({
          message: `Please complete: ${problems.join(", ")}.`,
          severity: "error",
        }),
      );
      return;
    }

    try {
      let _data: any = { ...data };

      /*
       * A non-refill cannot have a top-up destination.
       *
       * The field is only rendered for phone-refill now, but hiding an input
       * does not empty the value behind it: switch an existing refill to a
       * gift card and the destination it used to carry would still be saved,
       * invisibly. Cleared here rather than in an effect on productType,
       * because an effect races the form being populated from a loaded
       * product and would wipe a legitimate value on open.
       *
       * This is the data that made "show me top-ups for India" answer with
       * gift cards.
       */
      if (_data.productType !== "phone-refill") {
        _data.topUpCountryIsoCodes = [];
      }

      // Only send gallery URLs to the API payload
      _data.productGallery = extractGalleryUrls(_data.productGallery);

      // Map form discount field names to DB field names
      // discountApplyTo: 'entire-product' -> 'product', 'per-denomination' -> 'denomination'
      if (_data.discountApplyTo === 'entire-product') {
        _data.discountApplyTo = 'product';
      } else if (_data.discountApplyTo === 'per-denomination') {
        _data.discountApplyTo = 'denomination';
      }
      // discountType: 'fixed' -> 'flat' (percentage stays the same)
      if (_data.discountType === 'fixed') {
        _data.discountType = 'flat';
      }
      // productLevelDiscount -> productDiscount
      if (_data.productLevelDiscount) {
        _data.productDiscount = {
          onlinePayment: Number(_data.productLevelDiscount.onlinePayment) || 0,
          bankTransfer: Number(_data.productLevelDiscount.bankTransfer) || 0,
        };
        delete _data.productLevelDiscount;
      }

      // if (data?.productDenominations.length === 0) {
      //   _data['simplePrice'] = 0;
      // }
      if (data?.countryIsoCodes) {
        _data["countryIsoCodes"] = data?.countryIsoCodes;
      }

      let result: any = "";

      if (id) {
        result = await createAndUpdateProduct({
          id,
          data: _data,
        }).unwrap();
      } else {
        result = await createAndUpdateProduct({ data: _data }).unwrap();
      }

      dispatch(
        showSnackbar({
          message: id
            ? "Product updated successfully!"
            : "Product created successfully!",
          severity: "success",
        }),
      );

      // Saved, so the unsaved-changes guard must stand aside for this one.
      savedRef.current = true;
      navigate(-1);
      // navigate(id ? '/products' : `/products-link-with-supplier/${result?.data?._id}`);
    } catch (err: any) {
      dispatch(
        showSnackbar({
          message: err?.data?.message || "Failed to save product",
          severity: "error",
        }),
      );
    }
  };

  const handleViewImpact = async () => {
    if (!id) return;
    try {
      // Map form values to API values
      const rawApplyTo = watch("discountApplyTo");
      const rawType = watch("discountType");
      const apiApplyTo = rawApplyTo === "entire-product" ? "product" : "denomination";
      const apiType = rawType === "fixed" ? "flat" : rawType;

      const payload: any = {
        productIds: [id],
        discountApplyTo: apiApplyTo,
        discountType: apiType,
      };

      if (apiApplyTo === "product") {
        payload.productDiscount = {
          onlinePayment: Number(watch("productLevelDiscount.onlinePayment")) || 0,
          bankTransfer: Number(watch("productLevelDiscount.bankTransfer")) || 0,
        };
      } else {
        // Per-denomination: collect discount from each denomination
        const denoms = watch("productDenominations") || [];
        payload.denominationDiscounts = denoms
          .filter((d: any) => d.discount && (d.discount.onlinePayment > 0 || d.discount.bankTransfer > 0))
          .map((d: any) => ({
            productDenominationsku: d.productDenominationsku,
            discount: {
              discountType: d.discount?.discountType === "fixed" ? "flat" : (d.discount?.discountType || apiType),
              onlinePayment: Number(d.discount?.onlinePayment) || 0,
              bankTransfer: Number(d.discount?.bankTransfer) || 0,
            },
          }));
      }

      const result = await bulkPreview(payload).unwrap();
      const productResult = result.data?.results?.[0] || null;
      setImpactData(productResult);
      setIsImpactVisible(true);
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.data?.message || "Failed to preview discount impact",
          severity: "error",
        }),
      );
    }
  };

  function handleEANGenerate() {
    const calculateChecksum = (eanBase: any) => {
      const sum = eanBase.reduce((acc: any, digit: any, index: number) => {
        return acc + digit * (index % 2 === 0 ? 1 : 3);
      }, 0);
      const checksum = (10 - (sum % 10)) % 10;
      return checksum;
    };

    const eanBase = Array.from({ length: 12 }, () =>
      Math.floor(Math.random() * 10),
    );
    const checksum = calculateChecksum(eanBase);
    return eanBase.join("") + checksum;
  }

  const valuetext = (value: number) => `€${value}`;

  // Add breadcrumb items based on whether we're editing or adding
  const breadcrumbItems = [
    // { label: "Dashboard", path: "dashboard" },
    { label: "Product List", path: "products" },
    { label: id ? "Edit Product" : "Add Product" },
  ];

  const formState = watch();
  const productDenominations = watch("productDenominations");

  const [uploadMultipleFiles] = useUploadMultipleFilesMutation();
  const [deleteSingleFile] = useDeleteSingleFileMutation();

  const normalizeUploadedFiles = (result: any) => {
    if (Array.isArray(result?.data)) return result.data;
    if (Array.isArray(result?.urls)) {
      return result.urls.map((url: string) => ({ url }));
    }
    if (Array.isArray(result)) {
      return result.map((item: any) =>
        typeof item === "string" ? { url: item } : item,
      );
    }
    return [];
  };

  const getRecordIdFromGalleryItem = (item: any) => {
    if (item && typeof item === "object") {
      return item.recordId || item._id || item.id || item.key;
    }
    return undefined;
  };

  const getUrlFromGalleryItem = (item: any) => {
    if (!item) return undefined;
    if (typeof item === "string") return item;
    if (typeof item === "object") {
      return (
        item.url ||
        item.Location ||
        item.filePath ||
        (item as any)?.path ||
        (item as any)?.secure_url
      );
    }
    return undefined;
  };

  const buildDeletePayload = (recordId?: string, url?: string) => {
    if (recordId) return { recordId };
    if (url) return { url };
    return null;
  };

  const extractGalleryUrls = (gallery: any[]) => {
    if (!Array.isArray(gallery)) return [];

    return gallery
      .map((item) => {
        if (!item) return null;
        if (typeof item === "string") return item;
        if (typeof item === "object") {
          return (
            item.url ||
            item.Location ||
            item.filePath ||
            (item as any)?.path ||
            (item as any)?.secure_url
          );
        }
        return null;
      })
      .filter((url): url is string => Boolean(url));
  };

  const autoCropGalleryImage = (file: File): Promise<File | string> => {
    return new Promise((resolve) => {
      const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
      if (!allowedTypes.includes(file.type)) {
        return resolve(`${file.name}: Only JPEG, PNG, and WEBP files are allowed`);
      }

      const img = new Image();
      const reader = new FileReader();
      reader.onload = (e) => {
        if (!e.target?.result) return resolve(`${file.name}: Could not read file`);
        img.src = e.target.result as string;
        img.onload = () => {
          if (img.width < 800 || img.height < 530) {
            return resolve(`${file.name}: Image too small. Minimum: 800x530px. Current: ${img.width}x${img.height}`);
          }

          // Auto center-crop to 3:2 ratio, then resize to 1200x800
          const targetRatio = 3 / 2;
          const srcRatio = img.width / img.height;
          let sx = 0, sy = 0, sw = img.width, sh = img.height;
          if (srcRatio > targetRatio) {
            // Image is wider — crop sides
            sw = img.height * targetRatio;
            sx = (img.width - sw) / 2;
          } else if (srcRatio < targetRatio) {
            // Image is taller — crop top/bottom
            sh = img.width / targetRatio;
            sy = (img.height - sh) / 2;
          }

          const canvas = document.createElement('canvas');
          canvas.width = 1200;
          canvas.height = 800;
          const ctx = canvas.getContext('2d');
          if (!ctx) return resolve(`${file.name}: Canvas error`);

          // These are exported as JPEG, which has no alpha channel, so any
          // transparency in a PNG or WEBP renders BLACK unless something is
          // painted underneath first. A transparent logo uploaded as a gallery
          // image came out as a black rectangle, and the customer portal shows
          // it with object-contain so the block is plainly visible.
          // ImageCropper does the same fill for the main product image; this
          // path was force-converting to JPEG without it.
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, 1200, 800);

          ctx.drawImage(img, sx, sy, sw, sh, 0, 0, 1200, 800);

          canvas.toBlob((blob) => {
            if (!blob) return resolve(`${file.name}: Crop failed`);
            const name = file.name.replace(/\s+/g, '').replace(/\.[^/.]+$/, '');
            resolve(new File([blob], `${name}.jpg`, { type: 'image/jpeg' }));
          }, 'image/jpeg', 0.85);
        };
        img.onerror = () => resolve(`${file.name}: Invalid image file`);
      };
      reader.readAsDataURL(file);
    });
  };

  const handleGalleryUpload = async (files: FileList) => {
    setIsUploading(true);
    try {
      const fileArray = Array.from(files);

      // Auto-crop all gallery images to 1200x800
      const cropResults = await Promise.all(fileArray.map(autoCropGalleryImage));
      const cropErrors = cropResults.filter((r): r is string => typeof r === 'string');
      if (cropErrors.length > 0) {
        dispatch(showSnackbar({ message: cropErrors[0], severity: 'error' }));
        setIsUploading(false);
        return;
      }
      const croppedFiles = cropResults as File[];

      const result: any = await uploadMultipleFiles(croppedFiles).unwrap();

      const uploadedItems = normalizeUploadedFiles(result);

      if (uploadedItems.length > 0) {
        const updatedGallery = [...galleryFiles, ...uploadedItems];
        setGalleryFiles(updatedGallery);
        setValue("productGallery", updatedGallery);

        dispatch(
          showSnackbar({
            message: `${uploadedItems.length} image(s) uploaded successfully`,
            severity: "success",
          }),
        );
      }
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.data?.message || "Failed to upload images",
          severity: "error",
        }),
      );
    } finally {
      setIsUploading(false);
    }
  };

  const handleDeleteGalleryImage = async (index: number) => {
    const target = galleryFiles[index];
    const recordId = getRecordIdFromGalleryItem(target);
    const fileUrl = getUrlFromGalleryItem(target);

    const payload = buildDeletePayload(recordId, fileUrl);

    if (!payload) {
      dispatch(
        showSnackbar({
          message: "Unable to delete image: missing record id or url.",
          severity: "warning",
        }),
      );
      return;
    }

    try {
      await deleteSingleFile(payload).unwrap();
      // Filter out the deleted image and keep only remaining images
      const remainingImages = galleryFiles.filter((_, i) => i !== index);
      setGalleryFiles(remainingImages);
      setValue("productGallery", remainingImages);
    } catch (error) {
      dispatch(
        showSnackbar({
          message: "Failed to delete image from S3",
          severity: "error",
        }),
      );
    }
  };

  const handleDeleteUploadedImage = async (index: number) => {
    return handleDeleteGalleryImage(index);
  };

  const handleDeleteMultipleImages = async (indexes: number[]) => {
    const targets = indexes
      .map((index) => ({
        index,
        payload: buildDeletePayload(
          getRecordIdFromGalleryItem(galleryFiles[index]),
          getUrlFromGalleryItem(galleryFiles[index]),
        ),
      }))
      .filter((item) => item.payload);

    if (!targets.length) {
      dispatch(
        showSnackbar({
          message: "No selected images have a record id or url to delete.",
          severity: "warning",
        }),
      );
      return;
    }

    try {
      await Promise.all(
        targets.map((item) => deleteSingleFile(item.payload as any).unwrap()),
      );
      // Filter out deleted images and keep only remaining images
      const indexesToRemove = targets.map((item) => item.index);
      const remainingImages = galleryFiles.filter(
        (_, i) => !indexesToRemove.includes(i),
      );
      setGalleryFiles(remainingImages);
      setValue("productGallery", remainingImages);

      if (targets.length < indexes.length) {
        dispatch(
          showSnackbar({
            message:
              "Some selected images were missing record ids and were not removed.",
            severity: "warning",
          }),
        );
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: "Failed to delete some images from S3",
          severity: "error",
        }),
      );
    }
  };

  // const priceType = watch('priceType');

  const checkValidation = (
    newPrice: Types.ITopupProductDenominationSKUModel,
    isUpdate: boolean = false,
  ) => {
    // For updates, we need to exclude the current record being updated from duplicate checks
    const isDuplicateSKU = productDenominations.some(
      (item) =>
        item.productDenominationsku === newPrice.productDenominationsku &&
        (!isUpdate || (isUpdate && item._id !== newPrice._id)),
    );

    const isDuplicateDenomination =
      newPrice.type === "fixed" &&
      productDenominations.some(
        (item) =>
          item.denomination === newPrice.denomination &&
          item.type === "fixed" &&
          (!isUpdate || (isUpdate && item._id !== newPrice._id)),
      );

    const isDuplicateRange =
      newPrice.type === "range" &&
      productDenominations.some(
        (item) =>
          item.minValue === newPrice.minValue &&
          item.maxValue === newPrice.maxValue &&
          item.type === "range" &&
          (!isUpdate || (isUpdate && item._id !== newPrice._id)),
      );

    if (isDuplicateDenomination) {
      dispatch(
        showSnackbar({
          message: "Error: Fixed denomination value must be unique.",
          severity: "error",
        }),
      );
      return false;
    }

    if (isDuplicateSKU) {
      dispatch(
        showSnackbar({
          message: "Error: Product Denomination SKU must be unique.",
          severity: "error",
        }),
      );
      return false;
    }

    if (isDuplicateRange) {
      dispatch(
        showSnackbar({
          message:
            "Error: Range with the same min and max values must be unique.",
          severity: "error",
        }),
      );
      return false;
    }
    return true;
  };

  const handleAddFixedPrice = (obj: any) => {
    let empteyValue: Types.sendReceiveValue = {
      denomination: 0,
      max: 0,
      min: 0,
    };
    const newPrice: Types.ITopupProductDenominationSKUModel = {
      productDenominationsku: obj.productDenominationsku.toUpperCase(),
      denomination: obj.denomination,
      minValue: obj.minValue,
      maxValue: obj.maxValue,
      denominationDescription: obj.denominationDescription,
      denominationStatus: obj.denominationStatus,
      type: obj.type,
      receiveValue: obj.receiveValue || empteyValue,
      sendValue: obj.sendValue || empteyValue,
      receiveCurrencyISO: obj.receiveCurrencyISO || "",
      sendCurrencyISO: obj.sendCurrencyISO || "",
      packType: obj.packType || "",
      discount: obj.discount,
    };
    const isValid: boolean = checkValidation(newPrice);
    if (!isValid) return isValid;

    const updatedProductDenominations = [
      ...productDenominations,
      newPrice,
    ].filter((item) => item.productDenominationsku);
    setValue("productDenominations", updatedProductDenominations);
    return isValid;
  };

  const handleUpdateFixedPrice = (
    obj: any,
    index: number,
    existingVal: any,
  ) => {
    let empteyValue: Types.sendReceiveValue = {
      denomination: 0,
      max: 0,
      min: 0,
    };
    const newPrice: Types.ITopupProductDenominationSKUModel = {
      productDenominationsku: obj.productDenominationsku.toUpperCase(),
      denomination: obj.denomination,
      denominationDescription: obj.denominationDescription,
      minValue: obj.minValue,
      maxValue: obj.maxValue,
      denominationStatus: obj.denominationStatus,
      type: obj.type,
      receiveValue: existingVal?.receiveValue || empteyValue,
      sendValue: existingVal?.sendValue || empteyValue,
      receiveCurrencyISO: existingVal?.receiveCurrencyISO || "",
      sendCurrencyISO: existingVal?.sendCurrencyISO || "",
      packType: existingVal?.packType || "",
      _id: existingVal?._id,
      discount: obj.discount,
    };
    const isValid: boolean = checkValidation(newPrice, true);
    if (!isValid) return isValid;
    // setexistingVal({ index: -1 });
    setValue(
      "productDenominations",
      productDenominations.map(
        (item, i) => (i === index ? newPrice : item), // Update only the matching index
      ),
    );
    return isValid;
  };

  /**
   * Requests confirmation before deleting a fixed price, and removes the price if confirmed
   * @param priceToRemove The price to remove
   */
  const handleRemoveFixedPrice = (
    priceToRemove: Types.ITopupProductDenominationSKUModel,
  ) => {
    requestConfirmation({
      title: "Delete Denomination",
      message: `Are you sure you want to delete this denomination?`,
      onConfirm: async () => {
        setValue(
          "productDenominations",
          productDenominations.filter(
            (price) =>
              price.productDenominationsku !==
              priceToRemove.productDenominationsku,
          ),
        );
      },
      onCancel: () => {},
    });
  };

  const handleEditFixedPrice = (
    item: Types.ITopupProductDenominationSKUModel,
    index: number,
  ) => {
    setRange({
      minValue: Number(item.minValue),
      maxValue: Number(item.maxValue),
    });
    setSelectedOwnPriceTypeValue(item.type);
    // Load the status of the denomination being edited. With this commented out
    // the dropdown kept whatever value the form already held -- the "active"
    // default, or a status chosen for a DIFFERENT denomination earlier in the
    // session -- and saving wrote that stale value onto this row. A denomination
    // could be switched to inactive without anyone choosing it, which then hid
    // it from the shop.
    setSelectedDenominationValue(item.denominationStatus || "active");
    setMultiplePriceTempData({ ...item, index: index });
    if (item.type === "fixed") {
      const denomination: any = document.getElementById(
        "denomination",
      ) as HTMLInputElement;
      denomination.value = item.denomination.toString();
    }
    const productDenominationsku: any = document.getElementById(
      "productDenominationsku",
    ) as HTMLInputElement;
    const denominationDescription: any = document.getElementById(
      "denominationDescription",
    ) as HTMLInputElement;
    productDenominationsku.value = item.productDenominationsku;
    denominationDescription.value = item.denominationDescription;
    // Populate discount values
    setDenominationDiscount({
      discountType: item.discount?.discountType || 'percentage',
      onlinePayment: item.discount?.onlinePayment || 0,
      bankTransfer: item.discount?.bankTransfer || 0,
    });
  };

  // useEffect(() => {
  //   setValue('productDenominations', productDenominations.length > 0 ? productDenominations : []);
  // }, [productDenominations, setValue]);

  // First, let's create a type conversion function to work with both types
  const convertToCategoryFormModel = (category: any): CategoryFormModel => {
    return {
      _id: category._id || "", // Ensuring _id is never undefined
      categoryName: category.categoryName,
      // Add any other required fields from CategoryFormModel here
    };
  };

  // useEffect(() => {
  //   let tempCountries = watch('countries') || [];
  //   console.log('tempCountries', tempCountries);
  //   const filteredCountries: any = countriesDialingData?.filter((item: any) => !tempCountries.includes(item.value)) || [];
  //   setValue('countries', [...tempCountries, ...filteredCountries]);
  // }, [watch('countries')]);

  // Move this outside of the render function
  const [searchTerm, setSearchTerm] = useState("");
  // Use effect to handle API calls based on search term changes
  useEffect(() => {
    if (searchTerm.length > 2) {
      Utils.debounce(() => {
        searchCategoryTrigger(searchTerm);
      }, 500)();
    }
  }, [searchTerm, searchCategoryTrigger]);

  const checkAllCountryHaveSameCurrency = (selectedCountry: string[]): any => {
    if (Array.isArray(selectedCountry) && selectedCountry.length === 0) {
      setSelectedCurrency({ symbol: "€", allValidCurrencies: true });
      return;
    }

    const matchedCountries = countriesDialingData.filter((country: any) =>
      selectedCountry.includes(country.value),
    );

    // Extract currency symbols
    const extractedSymbols = matchedCountries
      .map((country: any) => {
        const currency = country?.extraData?.currencies;
        if (!currency) return null;
        const firstCurrencyKey = Object.keys(currency)[0];
        return currency[firstCurrencyKey]?.symbol ?? null;
      })
      .filter(Boolean); // remove null/undefined
    const uniqueSymbols = Array.from(new Set(extractedSymbols));

    //  Get the first selected country's symbol explicitly
    const firstCountry = countriesDialingData.find(
      (country: any) => country.value === selectedCountry[0],
    );
    let firstSymbol: string | null = null;
    if (firstCountry && firstCountry?.extraData?.currencies) {
      const keys = Object.keys(firstCountry.extraData.currencies);
      if (keys.length > 0) {
        firstSymbol = keys[0]; // e.g., "INR"
        firstSymbol =
          firstCountry.extraData.currencies[firstSymbol]?.symbol ?? null; // e.g., "₹"
      }
    }

    if (Array.isArray(selectedCountry) && selectedCountry.length === 1) {
      setSelectedCurrency({
        symbol: firstSymbol || "€",
        allValidCurrencies: true,
      });
    } else {
      setSelectedCurrency({
        symbol: firstSymbol || "€",
        allValidCurrencies: uniqueSymbols.length === 1,
      });
    }
  };

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (isDirty) {
        e.preventDefault();
        // Required for Chrome to trigger the dialog
        e.returnValue =
          "You have unsaved changes. Are you sure you want to leave?";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isDirty]);

  /**
   * Stop a half-finished product being lost to a click in the sidebar.
   *
   * `beforeunload` above only fires when the BROWSER unloads -- closing the
   * tab, reloading, following an external link. Clicking "Tax Profile" in the
   * menu is a client-side route change: the browser never unloads, the handler
   * never runs, and the form is gone without a word. Cancel asks, closing the
   * tab asks, and the one exit people actually take did not.
   *
   * useBlocker stops the navigation itself, so the same confirmation the
   * Cancel button uses can be shown and the route resumed or abandoned on the
   * answer. Only while the form is dirty -- blocking a clean form would make
   * every menu click ask a pointless question.
   */
  /*
   * A successful save is not an abandoned edit.
   *
   * The form is still dirty at the moment it saves -- react-hook-form has no
   * reason to think otherwise -- so the navigation that FOLLOWS a save was
   * blocked by this guard and asked "Leaving now will discard them". The
   * product had already been created. Cancelling put the person back on a
   * form whose contents were now a duplicate, and the next click returned
   * 409 "A product with this name already exists", which reads as the save
   * having failed when it had in fact succeeded twice over.
   *
   * A ref rather than resetting the form: this is read during the navigation
   * that the save itself triggers, in the same tick, and a state update would
   * not have landed yet.
   */
  const savedRef = useRef(false);

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isDirty &&
      !savedRef.current &&
      currentLocation.pathname !== nextLocation.pathname,
  );

  useEffect(() => {
    if (blocker.state !== "blocked") return;
    requestConfirmation({
      title: "Unsaved changes detected",
      message:
        "You have unsaved changes on this product. Leaving now will discard them.",
      onConfirm: async () => blocker.proceed?.(),
      // Staying put is the safe default, so anything other than an explicit
      // confirmation puts the customer back on the form with their work.
      onCancel: () => blocker.reset?.(),
    });
  }, [blocker.state]);

  const handleCancel = () => {
    if (isDirty) {
      requestConfirmation({
        title: "Unsaved changes detected",
        message: `You have unsaved changes. Are you sure you want to leave?`,
        onConfirm: async () => {
          navigate("/products", { replace: true });
        },
        onCancel: () => {},
      });
    } else {
      navigate("/products", { replace: true });
    }
  };

  /**
   * Checks if a field value is duplicate and shows a snackbar if it is
   * @param field The field to check
   * @param value The value to check
   */
  type RequestType = "eanNumber" | "productsku" | "productDenominationsku";
  const checkFieldValueIsDuplicate = Utils.debounce(
    async (field: RequestType, value: string) => {
      const str = `/${field}/${value}${id ? `/${id}` : ""}`;
      const response: any = await checkProductFieldIsDuplicateOrNotTrigger(str);
      if (response?.error && response?.error?.status === 400) {
        const errMsg = `${
          field === "eanNumber"
            ? "EAN Number"
            : field === "productsku"
              ? "Product SKU"
              : "Product Denomination SKU"
        } already exists, Please enter a different value`;
        dispatch(
          showSnackbar({
            message: errMsg,
            severity: "error",
          }),
        );

        setIsDuplicateIssue(true);
        if (field === "productDenominationsku") {
          setErrorMsg(errMsg);
        } else {
          setError(field, { type: "manual", message: errMsg });
        }
      } else {
        setIsDuplicateIssue(false);
        setErrorMsg("");
      }
    },
    500,
  );

  return (
    <Box>
      {/* Breadcrumb */}
      <div style={{ flexGrow: 1 }}>
        <Breadcrumb items={breadcrumbItems} name={"Products"} />
      </div>

      <form
        onSubmit={handleSubmit(onSubmit, onInvalid)}
        style={{ marginTop: "20px" }}
      >
        {noDefaultTaxProfile ? (
          <Paper
            sx={{
              p: 2,
              mb: 2,
              border: "1px solid",
              borderColor: "error.light",
              bgcolor: "rgba(211,47,47,0.06)",
            }}
          >
            <Typography sx={{ fontSize: 14, fontWeight: 700, mb: 0.5 }}>
              No default tax profile
            </Typography>
            <Typography sx={{ fontSize: 13 }}>
              A product with no profile of its own inherits the default one, and
              there is no default set. Without it this product would be sold
              untaxed. Create a tax profile under Taxation and mark it as the
              default before adding products.
            </Typography>
          </Paper>
        ) : null}
        <Grid2 container spacing={2}>
          {/* Left Column - Main Content */}
          <Grid2 size={{ xs: 12, md: 8 }}>
            {/* Title Section */}
            <Paper sx={{ px: 2, pb: 2, pt: 1.5, mb: 2 }}>
              <Typography
                variant="subtitle2"
                sx={{ mb: 1, position: "relative" }}
              >
                Product name<em className="imp">*</em>
              </Typography>
              <Controller
                name="productName"
                control={control}
                rules={{
                  required: "Product name is required",
                  minLength: {
                    value: 3,
                    message: "Product name must be at least 3 characters",
                  },
                  maxLength: {
                    value: 100,
                    message: "Product name cannot exceed 100 characters",
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    fullWidth
                    size="small"
                    label="Product Name"
                    onInput={(e: any) => Utils.onlyText(e)}
                    placeholder="Enter product name"
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
              />

              {/* Category Description */}
              <Paper sx={{ py: 2, boxShadow: "none", position: "relative" }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  About Product(Short Description)<em className="imp">*</em>
                </Typography>
                <Grid2 size={12}>
                  <Controller
                    name="shortDescription"
                    control={control}
                    rules={{
                      // required: 'Category shortDescription is required',
                      minLength: {
                        value: 10,
                        message: "Description must be at least 10 characters",
                      },
                      maxLength: {
                        value: 5000,
                        message: "Description cannot exceed 500 characters",
                      },
                    }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="About Product"
                        className="custom-mui-textarea"
                        multiline
                        rows={8}
                        error={!!errors.shortDescription}
                        helperText={errors.shortDescription?.message}
                        placeholder="Enter category shortDescription"
                        sx={{ height: 150 }}
                        onChange={(e) => {
                          // Remove leading spaces
                          const value = e.target.value;
                          if (value.startsWith(" ")) {
                            field.onChange(value.trimStart());
                          } else {
                            field.onChange(value);
                          }
                        }}
                      />
                    )}
                  />
                </Grid2>
              </Paper>

              {/* Product Description */}
              <Paper
                sx={{
                  py: 2,
                  mt: 2,
                  mb: 2,
                  boxShadow: "none",
                  position: "relative",
                }}
              >
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  Descriptions(Long Description)<em className="imp">*</em>
                </Typography>
                {/* {isFormReady ? (
                  <Box
                    sx={{
                      "& .quill": {
                        borderRadius: 1,
                        "& .ql-toolbar": {
                          borderTopLeftRadius: 1,
                          borderTopRightRadius: 1,
                          backgroundColor: alpha(
                            theme.palette.primary.main,
                            0.03
                          ),
                        },
                        "& .ql-container": {
                          borderBottomLeftRadius: 1,
                          borderBottomRightRadius: 1,
                          minHeight: "200px",
                        },
                      },
                    }}
                  >
                    <Controller
                      name="fullDescription"
                      control={control}
                      rules={{
                        required: "Descriptions is required",
                        validate: (value) => {
                          if (
                            value.replace(/<(.|\n)*?>/g, "").trim().length === 0
                          ) {
                            return "Description cannot be empty";
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <>
                          <ReactQuill
                            theme="snow"
                            ref={field.ref}
                            value={field.value}
                            onChange={field.onChange}
                            placeholder={"Enter product description"}
                            preserveWhitespace={true}
                            modules={{
                              toolbar: [
                                [{ header: [1, 2, 3, false] }],
                                ["bold", "italic", "underline", "strike"],
                                [{ list: "ordered" }, { list: "bullet" }],
                                ["link", "image"],
                                ["clean"],
                              ],
                            }}
                          />
                          {errors.shortDescription && (
                            <Typography
                              color="error"
                              variant="caption"
                              sx={{ mt: 0.5, display: "block" }}
                            >
                              {errors.shortDescription.message}
                            </Typography>
                          )}
                        </>
                      )}
                    />
                  </Box>
                ) : (
                  <Skeleton variant="rectangular" width={"100%"} height={200} />
                )} */}
                {isFormReady ? (
                  <Box
                    onClick={() => {
                      // Focus the Quill editor when clicking anywhere in the container
                      if (fullDescriptionQuillRef.current) {
                        const quill = (
                          fullDescriptionQuillRef.current as any
                        ).getEditor?.();
                        if (quill) {
                          quill.focus();
                        }
                      }
                    }}
                    sx={{
                      "& .quill": {
                        borderRadius: 1,
                        border: errors.fullDescription
                          ? "1px solid red"
                          : "1px solid #ccc", // Add red border on error
                        "& .ql-toolbar": {
                          borderTopLeftRadius: 1,
                          borderTopRightRadius: 1,
                          backgroundColor: (theme) =>
                            alpha(theme.palette.primary.main, 0.03),
                        },
                        "& .ql-container": {
                          borderBottomLeftRadius: 1,
                          borderBottomRightRadius: 1,
                          minHeight: "200px",
                          cursor: "text",
                        },
                      },
                    }}
                  >
                    <Controller
                      name="fullDescription"
                      control={control}
                      rules={{
                        required: "Description is required",
                        validate: (value) => {
                          if (
                            value.replace(/<(.|\n)*?>/g, "").trim().length === 0
                          ) {
                            return "Description cannot be empty";
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <>
                          <ReactQuill
                            theme="snow"
                            ref={(el) => {
                              fullDescriptionQuillRef.current = el;
                              if (typeof field.ref === "function") {
                                field.ref(el);
                              }

                              // Set up keyboard bindings after the editor is mounted
                              if (el) {
                                const quill = (el as any).getEditor?.();
                                if (quill) {
                                  const keyboard = quill.getModule("keyboard");

                                  // Prevent space at the start
                                  keyboard.addBinding({
                                    key: " ",
                                    handler: function (range: any) {
                                      const text = quill.getText();
                                      const textBeforeCursor = text.slice(
                                        0,
                                        range.index,
                                      );

                                      // Allow space if there's non-whitespace content before cursor
                                      if (
                                        range.index === 0 ||
                                        /^[\s\n]*$/.test(textBeforeCursor)
                                      ) {
                                        return false; // Prevent the space
                                      }
                                      return true; // Allow the space
                                    },
                                  });

                                  // Prevent tab at the start
                                  keyboard.addBinding({
                                    key: 9, // Tab key code
                                    handler: function (range: any) {
                                      const text = quill.getText();
                                      const textBeforeCursor = text.slice(
                                        0,
                                        range.index,
                                      );

                                      // Allow tab if there's non-whitespace content before cursor
                                      if (
                                        range.index === 0 ||
                                        /^[\s\n]*$/.test(textBeforeCursor)
                                      ) {
                                        return false; // Prevent the tab
                                      }
                                      return true; // Allow the tab
                                    },
                                  });
                                }
                              }
                            }}
                            value={field.value}
                            onChange={(content, delta, source, editor) => {
                              // Get the plain text content
                              const text = editor.getText();

                              // Check if content starts with whitespace (spaces, tabs, newlines)
                              if (/^[\s\n\t]+/.test(text)) {
                                // Remove leading whitespace from HTML
                                // This regex handles: spaces, &nbsp;, tabs, and newlines at the start
                                let cleanedContent = content
                                  .replace(
                                    /^(<p[^>]*>)(\s|&nbsp;|\t|\n)+/g,
                                    "$1",
                                  )
                                  .replace(/^(\s|&nbsp;|\t|\n)+/g, "");

                                // Additional check for nested tags
                                cleanedContent = cleanedContent.replace(
                                  /(<p[^>]*>)(<[^>]+>)*(\s|&nbsp;|\t)+/g,
                                  "$1$2",
                                );

                                field.onChange(cleanedContent);
                                return;
                              }

                              field.onChange(content);
                            }}
                            placeholder={"Enter product description"}
                            preserveWhitespace={true}
                            modules={{
                              toolbar: [
                                [{ header: [1, 2, 3, false] }],
                                ["bold", "italic", "underline", "strike"],
                                [{ list: "ordered" }, { list: "bullet" }],
                                ["link", "image"],
                                ["clean"],
                              ],
                            }}
                          />
                          {errors.fullDescription && (
                            <Typography
                              color="error"
                              variant="caption"
                              sx={{ mt: 0.5, display: "block" }}
                            >
                              {errors.fullDescription.message}
                            </Typography>
                          )}
                        </>
                      )}
                    />
                  </Box>
                ) : (
                  <Skeleton variant="rectangular" width={"100%"} height={200} />
                )}
              </Paper>
            </Paper>

            {/* Product Codes */}
            <Paper sx={{ px: 2, pb: 2, pt: 1.5, mb: 2, position: "relative" }}>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Product Codes<em className="imp">*</em>
              </Typography>
              <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, sm: 6 }}>
                  <Controller
                    name="productsku"
                    control={control}
                    rules={{
                      required: "SKU is required",
                      minLength: {
                        value: 3,
                        message: "SKU must be at least 3 characters",
                      },
                      maxLength: {
                        value: 50,
                        message: "SKU cannot exceed 50 characters",
                      },
                      pattern: {
                        value: /^[A-Za-z0-9-_]+$/,
                        message:
                          "SKU can only contain letters, numbers, hyphens, and underscores",
                      },
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        {...field}
                        fullWidth
                        size="small"
                        label="SKU"
                        onInput={(e: any) => Utils.onlyText(e)}
                        placeholder="Enter SKU"
                        error={!!error}
                        helperText={error?.message}
                        onKeyUp={(e: any) => {
                          checkFieldValueIsDuplicate(
                            "productsku",
                            e.target.value,
                          );
                        }}
                      />
                    )}
                  />
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 6 }}>
                  <Controller
                    name="eanNumber"
                    control={control}
                    rules={{
                      required: "EAN Number is required",
                      minLength: {
                        value: 8,
                        message: "EAN Number must be 8 digits",
                      },
                      maxLength: {
                        value: 13,
                        message: "EAN Number must be 13 digits",
                      },
                      pattern: {
                        value: /^[0-9]+$/,
                        message: "EAN Number can only contain numbers",
                      },
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        {...field}
                        fullWidth
                        type="number"
                        size="small"
                        label="EAN Number"
                        placeholder="Your product EAN"
                        error={!!error}
                        helperText={error?.message}
                        onKeyUp={(e: any) => {
                          checkFieldValueIsDuplicate(
                            "eanNumber",
                            e.target.value,
                          );
                        }}
                      />
                    )}
                  />
                  {/* <Button size="small" onClick={handleEANGenerate} sx={{ mt: 1 }}>Generate</Button> */}
                </Grid2>
              </Grid2>
            </Paper>

            {/* Product Images */}
            <Paper sx={{ px: 2, pb: 2, pt: 1.5, mb: 2 }}>
              {/* <Typography variant="subtitle2" sx={{ mb: 1 }}>Product Main Image</Typography> */}
              <Controller
                name="productImage"
                control={control}
                rules={{ required: "Product image is required" }}
                render={({ field: { onChange, value } }) => (
                  <FileUploader
                    register={register}
                    value={formState.productImage}
                    isCrop={true}
                    cropWidth={1200}
                    cropHeight={800}
                    minWidth={800}
                    minHeight={530}
                    maxFileSizeKB={200}
                    setValue={(val: any) => {
                      setValue("productImage", val, { shouldValidate: true });
                      onChange(val);
                    }}
                    clearErrors={clearErrors}
                    errors={errors}
                    label={
                      <span style={{ position: "relative" }}>
                        Product Image{" "}
                        <span style={{ fontSize: "10px", color: "#bababa" }}>
                          (1200 X 800, max 200KB)
                        </span>{" "}
                        <em className="imp">*</em>
                      </span>
                    }
                  />
                )}
              />
            </Paper>
          </Grid2>

          {/* Right Column - Product Status and Organization */}
          <Grid2 size={{ xs: 12, md: 4 }}>
            {/* Product Status */}
            <Paper sx={{ px: 2, pb: 2, pt: 1, mb: 2 }}>
              <Typography variant="subtitle2" sx={{ mb: 0.8 }}>
                Product Status
              </Typography>
              <Controller
                name="productStatus"
                control={control}
                rules={{ required: "Status is required" }}
                render={({ field }) => (
                  <FormControl
                    fullWidth
                    size="small"
                    error={!!errors.productStatus}
                  >
                    <InputLabel>Status</InputLabel>
                    <Select {...field} label="Status" sx={{ height: 44 }}>
                      {statusOptions.map((option: any, index: number) => (
                        <MenuItem
                          key={`${option.value}-${index}`}
                          value={option.value}
                          sx={{ fontSize: "14px" }}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.productStatus && (
                      <FormHelperText>
                        {errors.productStatus.message}
                      </FormHelperText>
                    )}
                  </FormControl>
                )}
              />

              {/* Product Type */}
              <Typography variant="subtitle2" sx={{ mt: 2, mb: 0.8 }}>
                Product Type
              </Typography>
              <Controller
                name="productType"
                control={control}
                rules={{ required: "Product type is required" }}
                /**
                 * Render the product type select field. This field is required.
                 *
                 * The options are:
                 * - 'cards' for gift cards
                 * - 'phone-refill' for recharges
                 *
                 * The field also displays a helper text based on the selected value.
                 * For 'cards', the helper text is 'This product type is for gift cards'.
                 * For 'phone-refill', the helper text is 'This product type is for recharges'.
                 *
                 * @param {{ field: Object }} param0
                 * @returns {ReactNode}
                 */
                render={({ field }) => (
                  <FormControl
                    fullWidth
                    size="small"
                    error={!!errors.productType}
                  >
                    <InputLabel>Product Type</InputLabel>
                    <Select {...field} label="Product Type" sx={{ height: 44 }}>
                      {productTypeOptions.map((option: any, index: number) => (
                        <MenuItem
                          key={`pt-${option.value}-${index}`}
                          value={option.value}
                          sx={{ fontSize: "14px" }}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.productType && (
                      <FormHelperText>
                        {errors.productType.message}
                      </FormHelperText>
                    )}
                    {getValues("productType") === "cards" && (
                      <FormHelperText>
                        This product type is for gift cards
                      </FormHelperText>
                    )}
                    {getValues("productType") === "phone-refill" && (
                      <FormHelperText>
                        This product type is for recharges
                      </FormHelperText>
                    )}
                  </FormControl>
                )}
              />
              {/* Product Category */}
              {categoryList &&
                Array.isArray(categoryList) &&
                categoryList?.length > 0 && (
                  <>
                    <Typography
                      variant="subtitle2"
                      sx={{ mb: 0.8, mt: 1.5, position: "relative" }}
                      id="categoryId"
                      // sx={{ mb: 1, position: "relative" }}
                    >
                      Product Category<em className="imp">*</em>
                    </Typography>
                    <Controller
                      name="categoryId"
                      control={control}
                      rules={{ required: "Category is required" }}
                      render={({ field }) => {
                        const findCategoryObject = (id: string): any | null => {
                          // if (!getProductData.categoryId) return null;
                          if (
                            Array.isArray(categoryList) &&
                            categoryList?.length > 0
                          ) {
                            const category = categoryList?.find(
                              (cat: any) => cat._id === id,
                            );
                            return category
                              ? convertToCategoryFormModel(category)
                              : null;
                          }
                          return [];
                        };
                        // Convert field.value to proper format for Autocomplete
                        const getCurrentCatValue = (): CategoryFormModel[] => {
                          if (!field.value) return [];
                          if (Array.isArray(field.value)) {
                            return field.value
                              .map((id) => findCategoryObject(id as string))
                              .filter(
                                (category): category is CategoryFormModel =>
                                  category !== null,
                              );
                          } else {
                            const category = findCategoryObject(
                              field.value as string,
                            );
                            return category ? [category] : [];
                          }
                        };

                        return (
                          <Autocomplete<CategoryFormModel, true>
                            multiple
                            id="category-autocomplete"
                            options={
                              Array.isArray(categoryList) &&
                              categoryList?.length
                                ? categoryList
                                    .filter(
                                      (cat: any) =>
                                        cat?.isDelete === false &&
                                        cat.isActive === true,
                                    )
                                    .map(convertToCategoryFormModel)
                                : []
                            }
                            getOptionLabel={(option) => option.categoryName}
                            value={getCurrentCatValue()}
                            onChange={(_, newValue) => {
                              const values = newValue.map((item) => item._id);
                              field.onChange(values);
                              const categoryId = getValues("categoryId");
                              if (categoryId.length === 0) {
                                setCategoryError(
                                  "Please select at least one category",
                                );
                              } else {
                                setCategoryError("");
                              }
                            }}
                            size="small"
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Category"
                                error={!!errors.categoryId}
                                helperText={errors.categoryId?.message}
                                // Allow the input to grow based on content
                                InputProps={{
                                  ...params.InputProps,
                                  sx: {
                                    minHeight: 44,
                                    height: "auto",
                                    paddingY: 0.5,
                                  },
                                }}
                              />
                            )}
                            renderOption={(props, option) => (
                              <li {...props} key={option._id}>
                                {option.categoryName}
                              </li>
                            )}
                            isOptionEqualToValue={(option, value) =>
                              option._id === value._id
                            }
                            ChipProps={{
                              size: "small",
                            }}
                            ListboxProps={{
                              style: {
                                minHeight: 48 * 4.5 + 4.5,
                              },
                            }}
                            // Improve the tag styling and layout
                            renderTags={(value, getTagProps) =>
                              value.map((option, index) => (
                                <Chip
                                  label={option.categoryName}
                                  size="small"
                                  {...getTagProps({ index })}
                                  sx={{ m: 0.25, height: 24 }}
                                />
                              ))
                            }
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "auto !important",
                                minHeight: 44,
                                paddingY: 0.5,
                              },
                            }}
                          />
                        );
                      }}
                    />

                    {errors?.categoryId?.message ? (
                      <Typography
                        variant="subtitle2"
                        sx={{
                          mb: 1,
                          mt: "3px",
                          color: "#ff1744",
                          fontSize: "12px",
                        }}
                      >
                        {errors?.categoryId?.message}
                      </Typography>
                    ) : (isDirty && watch("categoryId").length === 0) ||
                      categoryError ? (
                      <Typography
                        variant="subtitle2"
                        sx={{
                          mb: 1,
                          mt: "3px",
                          color: "#ff1744",
                          fontSize: "12px",
                          position: "relative",
                        }}
                      >
                        Category field is required<em className="imp">*</em>
                      </Typography>
                    ) : (
                      ""
                    )}
                  </>
                )}

              {/* {getValues("productType") === "cards" && ( */}
              <Box sx={{ mt: 2 }}>
                <TextField
                  fullWidth
                  size="small"
                  label="Pin Length"
                  placeholder="Enter pin length"
                  type="number"
                  id="pinLengthInput"
                  {...register("pinLength", {
                    // Rules live in the resolver above, never here. A custom
                    // resolver on useForm REPLACES field-level rules outright,
                    // so the required/min/max that used to sit here never ran
                    // -- the form read as though pin length were enforced on
                    // every product type while nothing checked it.
                    valueAsNumber: true, // converts input to number
                  })}
                  error={!!errors.pinLength}
                  helperText={errors.pinLength?.message}
                  // onWheel={(e) => (e.target as HTMLInputElement).blur()}
                />
              </Box>
              {/* )} */}

              <div>
                <Controller
                  name={"isPopular"}
                  control={control}
                  defaultValue={false}
                  render={({
                    field: { onChange, value, ...field },
                    fieldState,
                  }) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          checked={Boolean(value)} // Ensure it's converted to a boolean
                          onChange={(e) => onChange(e.target.checked)} // Pass boolean value
                        />
                      }
                      label="Is it Popular?"
                      sx={{ mt: 2 }}
                    />
                  )}
                />

                <Controller
                  name={"isFeatured"}
                  control={control}
                  defaultValue={false}
                  render={({
                    field: { onChange, value, ...field },
                    fieldState,
                  }) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          checked={Boolean(value)}
                          onChange={(e) => onChange(e.target.checked)}
                        />
                      }
                      label="Is it Featured?"
                      sx={{ mt: 2 }}
                    />
                  )}
                />

                <Controller
                  name={"isPaysafe"}
                  control={control}
                  defaultValue={false}
                  render={({
                    field: { onChange, value, ...field },
                    fieldState,
                  }) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          checked={Boolean(value)}
                          onChange={(e) => onChange(e.target.checked)}
                        />
                      }
                      label="Is Paysafe? (Bank Transfer Only)"
                      sx={{ mt: 2 }}
                    />
                  )}
                />
              </div>

              <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, md: 12 }} style={{ marginTop: "20px" }}>
                  <FormControl
                    component="fieldset"
                    fullWidth
                    error={!!errors.redeemable}
                  >
                    <Typography variant="subtitle2">
                      Redeemable Options
                    </Typography>
                    <Controller
                      name="redeemable"
                      control={control}
                      rules={{ required: "Redeemable option is required" }}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          aria-label="redeemable"
                          name="redeemable"
                        >
                          <FormControlLabel
                            value="online"
                            control={<Radio />}
                            label="Online"
                          />
                          <FormControlLabel
                            value="in-store"
                            control={<Radio />}
                            label="In-Store"
                          />
                          <FormControlLabel
                            value="both"
                            control={<Radio />}
                            label="Both(Online & In-Store)"
                          />
                        </RadioGroup>
                      )}
                    />
                    {errors.redeemable && (
                      <FormHelperText>
                        {errors.redeemable.message}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid2>
              </Grid2>
            </Paper>

            {/* API Execution */}
            <Paper sx={{ px: 2, pb: 2, pt: 1, mb: 2 }}>
              <Typography variant="subtitle2" sx={{ mb: 0.8 }}>
                Api Execution
              </Typography>
              <Controller
                name="apiExecution"
                control={control}
                rules={{ required: "Api Execution is required" }}
                render={({ field }) => (
                  <FormControl
                    fullWidth
                    size="small"
                    error={!!errors.apiExecution}
                  >
                    <InputLabel>Api Execution</InputLabel>
                    <Select {...field} label="Api Execution">
                      {apiExecutionOptions.map((option: any, index: number) => (
                        <MenuItem
                          key={`ae-${option.value}-${index}`}
                          value={option.value}
                          sx={{ fontSize: "14px" }}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.apiExecution && (
                      <FormHelperText>
                        {errors.apiExecution.message}
                      </FormHelperText>
                    )}
                  </FormControl>
                )}
              />
            </Paper>

            {/* Stock Availability */}
            {/* <Paper sx={{ px: 2, pb: 2, pt: 1, mb: 2 }}>
              <Typography variant="subtitle2" sx={{ mb: 0.8 }}>
                Stock Availability<em className="opt">(Optional)</em>
              </Typography>
              <Controller
                name="inStock"
                control={control}
                rules={{}}
                render={({ field }) => (
                  <FormControl fullWidth size="small" error={!!errors.inStock}>
                    <InputLabel>Stock Status</InputLabel>
                    <Select {...field} label="Stock Status">
                      {stockOptions.map((option) => (
                        <MenuItem
                          key={option.value}
                          value={option.value}
                          sx={{ fontSize: "14px" }}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.inStock && (
                      <FormHelperText>{errors.inStock.message}</FormHelperText>
                    )}
                  </FormControl>
                )}
              />
            </Paper> */}

            {/* Search Page Listing */}
            <Paper sx={{ px: 2, pb: 2, pt: 1.5, mb: 2 }}>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Search Page Listing
              </Typography>
              <Grid2 container spacing={2}>
                {/* Page Title */}
                <Grid2 size={{ xs: 12 }}>
                  <Controller
                    name="titleTag"
                    control={control}
                    rules={{
                      maxLength: {
                        value: 70,
                        message: "Page title cannot exceed 70 characters",
                      },
                    }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        size="small"
                        label="Page Title"
                        error={!!errors.titleTag}
                        helperText={
                          errors.titleTag?.message ||
                          `${field.value.length}/70 characters`
                        }
                        placeholder="Enter page title"
                      />
                    )}
                  />
                </Grid2>

                {/* Meta Description */}
                <Grid2 size={{ xs: 12 }}>
                  <Controller
                    name="metaDescription"
                    control={control}
                    rules={{
                      maxLength: {
                        value: 160,
                        message:
                          "Meta shortDescription cannot exceed 160 characters",
                      },
                    }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        className={"custom-mui-textarea"}
                        size="small"
                        label="Meta Description"
                        multiline
                        rows={5}
                        error={!!errors.metaDescription}
                        helperText={
                          errors.metaDescription?.message ||
                          `${field.value.length}/160 characters`
                        }
                        placeholder="Enter meta shortDescription"
                      />
                    )}
                  />
                </Grid2>

                {/* URL Handle */}
                <Grid2 size={{ xs: 12 }}>
                  <Controller
                    name="productURL"
                    control={control}
                    rules={{
                      pattern: {
                        value: /^[a-z0-9-]+$/,
                        message:
                          "URL handle can only contain lowercase letters, numbers, and hyphens",
                      },
                    }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        size="small"
                        label="URL Handle"
                        error={!!errors.productURL}
                        helperText={errors.productURL?.message}
                        placeholder="enter-url-handle"
                      />
                    )}
                  />
                </Grid2>
              </Grid2>
            </Paper>
          </Grid2>
        </Grid2>

        <Box>
          {/* Additional Images */}
          <Paper sx={{ px: 2, pb: 2, pt: 1.5, mb: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
              Additional Images <span style={{ fontSize: "10px", color: "#bababa" }}>(auto-cropped to 1200 X 800, min 800x530)</span>
            </Typography>
            <Box sx={{ mb: 3 }}>
              <input
                type="file"
                multiple
                accept="image/png, image/jpeg, image/webp, image/jpg"
                id="gallery-upload"
                style={{ display: "none" }}
                onChange={(e) =>
                  e.target.files && handleGalleryUpload(e.target.files)
                }
              />
              <label htmlFor="gallery-upload">
                <Button
                  variant="outlined"
                  component="span"
                  startIcon={<FiUpload />}
                >
                  Upload Gallery Images
                </Button>
              </label>
            </Box>

            {galleryFiles.length > 0 && (
              <>
                <Suspense fallback={<div>Loading...</div>}>
                  <ImageGallery
                    files={galleryFiles}
                    // uploadedUrls={uploadedImages}
                    onDelete={handleDeleteGalleryImage}
                    onDeleteMultiple={handleDeleteMultipleImages}
                    onDeleteUrl={handleDeleteUploadedImage}
                    isUploading={isUploading}
                  />
                </Suspense>
                {isUploading && (
                  <Box
                    sx={{ display: "flex", justifyContent: "center", mt: 2 }}
                  >
                    <CircularProgress size={24} />
                    <Typography variant="body2" sx={{ ml: 1 }}>
                      Uploading images...
                    </Typography>
                  </Box>
                )}
              </>
            )}
          </Paper>

          {/*Define the type explicitly for better TypeScript support */}
          <Paper sx={{ px: 2, pb: 2, pt: 1, mb: 2 }}>
            {/*
              Say what this field is for.
              
              It was labelled "Country", full stop, while the destination field
              directly below it explains itself in a line. The unexplained one
              is the one doing three jobs -- tax, the storefront country
              filter, and whether a phone refill hands over a PIN or does a
              live recharge -- and the first question anyone asks on seeing
              both fields is what the difference is.
              
              Where a product is SOLD is not where a top-up LANDS. A Lyca India
              refill is sold in Germany, so German VAT applies, and the credit
              arrives in India. Both answers are needed and they are rarely the
              same.
            */}
            <Typography
              variant="subtitle2"
              sx={{ mb: 0.3, position: "relative" }}
              id="countryIsoCodes"
            >
              Where this product is sold<em className="imp">*</em>
            </Typography>
            <Typography
              variant="caption"
              sx={{ display: "block", mb: 1, color: "text.secondary" }}
            >
              Drives the tax applied to it, so the selected tax profile must
              have a rate for every country chosen here. This is where the
              customer buys, not where a top-up lands.
            </Typography>
            {isFormReady ? (
              <Controller
                name="countryIsoCodes"
                control={control}
                rules={{ required: "Country is required" }}
                render={({ field }) => {
                  // Helper function to ensure we're working with CountryNewModel objects
                  const findCountryObject = (
                    val: string,
                  ): CountryNewModel | null =>
                    countriesDialingData?.find(
                      (country: CountryNewModel) => country.value === val,
                    ) || null;
                  // Convert field.value to proper format for Autocomplete
                  const getCurrentValue = (): CountryNewModel[] => {
                    if (!field.value) return [];

                    if (Array.isArray(field.value)) {
                      return field.value
                        .map((val) => findCountryObject(val as string))
                        .filter(
                          (country): country is CountryNewModel =>
                            country !== null,
                        );
                    } else {
                      const country = findCountryObject(field.value as string);
                      return country ? [country] : [];
                    }
                  };
                  return (
                    <Autocomplete<CountryNewModel, true>
                      multiple
                      id="countries-autocomplete"
                      options={countriesDialingData || []}
                      getOptionLabel={(option) => {
                        // Handle the case when option might come in as a primitive
                        if (!option || typeof option !== "object") return "";
                        return option.label || "";
                      }}
                      value={getCurrentValue()}
                      onChange={async (_, newValue) => {
                        const values = newValue.map((item) => item.value);
                        const currentValues = field.value as string[] || [];

                        // Check if a country is being removed
                        const removedCountries = currentValues.filter(
                          (code: string) => !values.includes(code)
                        );

                        // If editing and a country is removed, check per-country supplier mapping
                        if (id && removedCountries.length > 0 && getProductData?.isSupplierMap) {
                          for (const countryCode of removedCountries) {
                            try {
                              const result = await checkCountryMappingTrigger({
                                productId: id,
                                countryCode,
                              }).unwrap();

                              if (result?.hasMapping) {
                                dispatch(
                                  showSnackbar({
                                    message: `Unable to remove country (${countryCode}). Active supplier mapping exists for this country. Please remove the mapping first.`,
                                    severity: "error",
                                  })
                                );
                                return; // Prevent the removal
                              }
                            } catch {
                              dispatch(
                                showSnackbar({
                                  message: "Failed to check country mapping. Please try again.",
                                  severity: "error",
                                })
                              );
                              return;
                            }
                          }
                        }

                        field.onChange(values);
                        checkManualyDenomination(false);
                      }}
                      // Don't set inputValue - it conflicts with the controller pattern
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Countries"
                          error={!!errors.countryIsoCodes}
                          helperText={errors.countryIsoCodes?.message}
                          InputProps={{
                            ...params.InputProps,
                            sx: {
                              minHeight: 44,
                              height: "auto",
                              paddingY: 0.5,
                            },
                          }}
                        />
                      )}
                      renderOption={(props, option) => (
                        <li {...props}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <div
                              style={{
                                display: "inline-block",
                                width: 20,
                                marginRight: 8,
                              }}
                            >
                              <img
                                src={option.extraData?.flag}
                                style={{ width: 25, height: "auto" }}
                                alt={option.label}
                              />
                            </div>
                            {option.label}
                          </div>
                        </li>
                      )}
                      isOptionEqualToValue={(option, value) => {
                        if (typeof value === "string")
                          return option.value === value;
                        return option.value === value.value;
                      }}
                      ChipProps={{
                        size: "small",
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "auto !important",
                          minHeight: 44,
                          paddingY: 0.5,
                        },
                        "& .MuiAutocomplete-input": {
                          minHeight: 44,
                          paddingY: 0.5,
                        },
                      }}
                    />
                  );
                }}
              />
            ) : null}

            {isDirty && watch("countryIsoCodes")?.length === 0 ? (
              <Typography
                color="error"
                variant="caption"
                sx={{ mt: 0.5, display: "block" }}
              >
                Please select at least one country
              </Typography>
            ) : countryIsoError ? (
              <Typography
                color="error"
                variant="caption"
                sx={{ mt: 0.5, display: "block" }}
              >
                {countryIsoError}
              </Typography>
            ) : null}

            <div style={{ marginTop: 10 }}>
              <b>Note:</b> If you're selecting multiple countries, please ensure
              they come under the same currency.
            </div>

            {!selectedCurrency.allValidCurrencies && (
              <Box
                sx={{
                  mt: 0,
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <FaCheckCircle
                  color={selectedCurrency.allValidCurrencies ? "green" : "red"}
                />
                <Typography
                  variant="subtitle2"
                  sx={{
                    color: selectedCurrency.allValidCurrencies
                      ? "green"
                      : "red",
                  }}
                >
                  {selectedCurrency.allValidCurrencies
                    ? "All currencies are valid"
                    : "Multiple currencies are not supported. Use the same currency for all options."}
                </Typography>
              </Box>
            )}
          </Paper>

          {/*
            Where the top-up lands, as opposed to where it is sold.

            The Country field above drives TAX -- it refuses a country the tax
            profile has no rate for -- so every international product sold to
            German customers is tagged Germany there, whatever it tops up. Lyca
            INT, Lebara and Vodafone all say Germany.

            That made "show me top-ups for India" unanswerable, and correcting
            the tax field to fix it would have meant demanding an Indian tax
            rate for a product sold in Germany. This is the separate answer.

            Optional: a product with nothing here still sells, it just will not
            appear under a destination filter.
          */}
          {/*
            Refills only. A gift card does not top anything up, so asking
            which country it tops up is a question with no answer -- and an
            optional field with no answer is one somebody eventually fills
            in. That already happened: the destination was seeded across
            every product and 15 gift cards ended up claiming a non-German
            destination, LangChain and Tableau among them, which is why the
            International Top-up listing has to filter on productType as
            well. The form should not have offered the field in the first
            place.
          */}
          {productType === "phone-refill" ? (
          <Paper sx={{ px: 2, pb: 2, pt: 1, mb: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 0.8 }}>
              Tops up which country
            </Typography>
            <Typography
              variant="caption"
              sx={{ display: "block", mb: 1, color: "text.secondary" }}
            >
              The one country the credit lands in. Different from Country
              above, which is where the product is sold and what its tax is
              based on. A product tops up a single country &mdash; for two
              destinations, create two products. Leave empty if it does not
              apply.
            </Typography>
            {/*
              This is what puts a product in the International Top-Up menu,
              and nothing on this form used to say so.

              The menu is built from this field -- any refill topping up
              somewhere other than Germany -- not from which category the
              product was filed under. An admin trying to get "Lyca India"
              into it went looking for a category to choose and found none
              that worked, because the answer was never a category.
            */}
            <Alert severity="info" sx={{ mb: 1.5, py: 0.25 }}>
              <Typography variant="caption">
                Choose a country other than Germany and this product appears
                in <strong>International Top-Up</strong> on the customer site.
                That menu is built from this field, not from the category
                below.
              </Typography>
            </Alert>
            {/*
              ONE country, not a list.
              
              This was a multi-select, and nothing downstream could honour
              more than one. Both portals and the app read the destination
              as `topUpCountryIsoCodes.find(c => c !== "DE")` -- the FIRST
              non-German entry -- so a product listing India and Pakistan
              showed +91 to everyone, and a Pakistani recharge went out with
              an Indian prefix. The form offered a choice the system could
              not keep.
              
              An operator belongs to one country, so one is also the honest
              model: Jio is India, Lyca India is India. Two destinations
              means two products.
              
              Still STORED as an array of one, so every existing product,
              query and $elemMatch keeps working untouched. Only the choice
              is narrowed.
            */}
            {isFormReady ? (
              <Controller
                name="topUpCountryIsoCodes"
                control={control}
                render={({ field }) => {
                  const current = Array.isArray(field.value)
                    ? field.value
                    : field.value
                      ? [field.value]
                      : [];
                  // A product saved before this was single-valued may hold
                  // several. Show the one that was actually in use -- the
                  // first non-German -- so the form matches the site.
                  const inUse =
                    current.find((c: string) => c && c !== "DE") ||
                    current[0] ||
                    "";

                  return (
                    <Autocomplete
                      size="small"
                      options={countriesDialingData || []}
                      getOptionLabel={(o: any) =>
                        typeof o === "string" ? o : o?.label || ""
                      }
                      value={
                        (countriesDialingData || []).find(
                          (c: any) => c.value === inUse,
                        ) || null
                      }
                      onChange={(_, chosen: any) =>
                        field.onChange(chosen?.value ? [chosen.value] : [])
                      }
                      isOptionEqualToValue={(o: any, v: any) =>
                        o.value === (typeof v === "string" ? v : v?.value)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select the destination country"
                        />
                      )}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "auto !important",
                          minHeight: 44,
                        },
                      }}
                    />
                  );
                }}
              />
            ) : null}
          </Paper>
          ) : null}

          {/* Discount Configuration */}
          <Paper sx={{ px: 2, pb: 2, pt: 1.5, mb: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 2 }}>
              Discount Configuration
            </Typography>
            <Grid2 container spacing={2}>
              {watch("discountApplyTo") === "entire-product" && (
                <Grid2 size={{ xs: 12, sm: 6, lg: 3 }}>
                  <Controller
                    name="discountType"
                    control={control}
                    render={({ field }) => (
                      <FormControl fullWidth size="small">
                        <InputLabel>Discount Type</InputLabel>
                        <Select {...field} label="Discount Type" sx={{ height: 44 }}>
                          <MenuItem value="percentage">Percentage (%)</MenuItem>
                          <MenuItem value="fixed">Fixed Amount (€)</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  />
                </Grid2>
              )}
              <Grid2 size={{ xs: 12, sm: 6, lg: 3 }}>
                <Controller
                  name="discountApplyTo"
                  control={control}
                  render={({ field }) => (
                    <FormControl fullWidth size="small">
                      <InputLabel>Apply Discount To</InputLabel>
                      <Select {...field} label="Apply Discount To" sx={{ height: 44 }}>
                        <MenuItem value="entire-product">Entire Product</MenuItem>
                        <MenuItem value="per-denomination">Per Denomination</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                />
              </Grid2>
            </Grid2>

            {/* Product Level Discount - Only show when "entire-product" is selected */}
            {watch("discountApplyTo") === "entire-product" && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                  Product Level Discount by Payment Method
                </Typography>
                <Grid2 container spacing={2}>
                  <Grid2 size={{ xs: 12, sm: 4, lg: 2 }}>
                    <Controller
                      name="productLevelDiscount.onlinePayment"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          onChange={(e) => {
                            const val = Number(e.target.value);
                            if (watch("discountType") === "percentage" && val > 100) {
                              dispatch(showSnackbar({ message: "Discount cannot exceed 100%", severity: "error" }));
                              return;
                            }
                            field.onChange(e);
                          }}
                          fullWidth
                          size="small"
                          label="Online Payment"
                          placeholder="0"
                          type="number"
                          onInput={Utils.onlyPriceNumber}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                {watch("discountType") === "percentage" ? "%" : "€"}
                              </InputAdornment>
                            ),
                          }}
                          sx={{ '& .MuiOutlinedInput-root': { pr: 1 } }}
                        />
                      )}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 4, lg: 2 }}>
                    <Controller
                      name="productLevelDiscount.bankTransfer"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          onChange={(e) => {
                            const val = Number(e.target.value);
                            if (watch("discountType") === "percentage" && val > 100) {
                              dispatch(showSnackbar({ message: "Discount cannot exceed 100%", severity: "error" }));
                              return;
                            }
                            field.onChange(e);
                          }}
                          fullWidth
                          size="small"
                          label="Bank Transfer"
                          placeholder="0"
                          type="number"
                          onInput={Utils.onlyPriceNumber}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                {watch("discountType") === "percentage" ? "%" : "€"}
                              </InputAdornment>
                            ),
                          }}
                          sx={{ '& .MuiOutlinedInput-root': { pr: 1 } }}
                        />
                      )}
                    />
                  </Grid2>
                </Grid2>
              </Box>
            )}

            {watch("discountApplyTo") === "per-denomination" && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="body2" color="text.secondary">
                  Discounts will be configured individually for each denomination in the pricing section below.
                </Typography>
              </Box>
            )}

            {/* View Impact button — only in edit mode */}
            {id && (
              <Box sx={{ mt: 2 }}>
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={isImpactLoading ? <CircularProgress size={16} /> : <MdPreview />}
                  onClick={handleViewImpact}
                  disabled={isImpactLoading}
                >
                  {isImpactLoading ? "Calculating..." : "View Impact"}
                </Button>

                <DiscountImpactTable
                  previewData={impactData}
                  isLoading={isImpactLoading}
                  visible={isImpactVisible}
                  onClose={() => {
                    setIsImpactVisible(false);
                    setImpactData(null);
                  }}
                />
              </Box>
            )}
          </Paper>

          {/* Pricing */}
          <Paper sx={{ px: 2, pb: 2, pt: 1.5, mb: 2 }}>
            <Typography
              variant="subtitle2"
              sx={{ mb: 2, position: "relative" }}
              id="denominationsSection"
            >
              Pricing<em className="imp">*</em>
            </Typography>
            <Box>
              <Grid2 container spacing={1} alignItems="stretch">
                {selectedOwnPriceTypeValue === "range" ? (
                  <>
                    <Grid2 size={{ xs: 12, sm: 6, lg: 1 }}>
                      <TextField
                        value={range.minValue}
                        onChange={(e) => {
                          setRange({
                            ...range,
                            minValue: Number(e.target.value),
                          });
                        }}
                        fullWidth
                        size="small"
                        label="Min Value"
                        placeholder={`${selectedCurrency.symbol} Enter price`}
                        onInput={Utils.onlyPriceNumber}
                        // error={!!fieldState.error}
                        // helperText={fieldState.error?.message || ''}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {selectedCurrency.symbol}
                            </InputAdornment>
                          ),
                        }}
                        sx={{ '& .MuiOutlinedInput-root': { pr: 1 } }}
                      />
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, lg: 1 }}>
                      <TextField
                        value={range.maxValue}
                        onChange={(e: any) => {
                          setRange({
                            ...range,
                            maxValue: Number(e.target.value),
                          });
                        }}
                        fullWidth
                        size="small"
                        label="Max Value"
                        placeholder={`${selectedCurrency.symbol} Enter price`}
                        onInput={Utils.onlyPriceNumber}
                        // error={!!fieldState.error}
                        // helperText={fieldState.error?.message || ''}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {selectedCurrency.symbol}
                            </InputAdornment>
                          ),
                        }}
                        sx={{ '& .MuiOutlinedInput-root': { pr: 1 } }}
                      />
                    </Grid2>
                  </>
                ) : (
                  <Grid2 size={{ xs: 12, sm: 6, lg: 2 }}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Price"
                      onInput={Utils.onlyPriceNumber}
                      placeholder="Enter Price"
                      InputLabelProps={{ shrink: true }}
                      id="denomination"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {selectedCurrency.symbol}
                          </InputAdornment>
                        ),
                      }}
                      sx={{ '& .MuiOutlinedInput-root': { pr: 1 } }}
                    />
                  </Grid2>
                )}

                <Grid2 size={{ xs: 12, sm: 6, lg: 2 }}>
                  <TextField
                    fullWidth
                    size="small"
                    label="SKU"
                    InputLabelProps={{ shrink: true }}
                    placeholder="Enter SKU"
                    inputProps={{
                      style: { textTransform: "uppercase" },
                      readOnly:
                        multiplePriceTempData.index === -1 ? false : true,
                    }}
                    type="text"
                    id="productDenominationsku"
                    onChange={(e: any) => {
                      checkFieldValueIsDuplicate(
                        "productDenominationsku",
                        e.target.value,
                      );
                    }}
                  />
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 6, lg: 3 }}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Description"
                    onInput={(e: any) => Utils.onlyText(e)}
                    InputLabelProps={{ shrink: true }}
                    placeholder="Enter Description"
                    type="text"
                    id="denominationDescription"
                  />
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 6, lg: 2 }}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Status</InputLabel>
                    <Select
                      label="Status"
                      value={selectedDenominationValue}
                      onChange={handleDenominationValueChange}
                      sx={{ height: 44 }}
                    >
                      {denominationStatusOptions.map((option) => (
                        <MenuItem
                          key={option.value}
                          value={option.value}
                          sx={{ fontSize: "14px" }}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 6, lg: 2 }}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Price&nbsp;Type</InputLabel>
                    <Select
                      label="Price Type"
                      value={selectedOwnPriceTypeValue}
                      onChange={(e) =>
                        setSelectedOwnPriceTypeValue(e.target.value as string)
                      }
                      sx={{ height: 44, textTransform: "capitalize" }}
                    >
                      {priceTypeOptions.map((option: any) => (
                        <MenuItem
                          key={`pt-${option.value}-${option.label}`}
                          value={option.value}
                          sx={{ fontSize: "14px", textTransform: "capitalize" }}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid2>

                {/* Discount fields for per-denomination */}
                {watch("discountApplyTo") === "per-denomination" && (
                  <>
                    <Grid2 size={{ xs: 12, sm: 4, lg: 1 }}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Discount Type</InputLabel>
                        <Select
                          value={denominationDiscount.discountType}
                          label="Discount Type"
                          onChange={(e) =>
                            setDenominationDiscount({
                              ...denominationDiscount,
                              discountType: e.target.value as 'percentage' | 'flat',
                            })
                          }
                        >
                          <MenuItem value="percentage">%</MenuItem>
                          <MenuItem value="flat">€</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 4, lg: 1 }}>
                      <TextField
                        fullWidth
                        size="small"
                        label={denominationDiscount.discountType === "percentage" ? "Online Disc. %" : "Online Disc. €"}
                        id="discountOnlinePayment"
                        placeholder="0"
                        type="number"
                        value={denominationDiscount.onlinePayment}
                        onChange={(e) => {
                          const raw = e.target.value;
                          if (raw !== '' && denominationDiscount.discountType === "percentage" && Number(raw) > 100) {
                            dispatch(showSnackbar({ message: "Discount cannot exceed 100%", severity: "error" }));
                            return;
                          }
                          setDenominationDiscount({
                            ...denominationDiscount,
                            onlinePayment: raw === '' ? '' : Number(raw),
                          });
                        }}
                        onInput={Utils.onlyPriceNumber}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {denominationDiscount.discountType === "percentage" ? "%" : "€"}
                            </InputAdornment>
                          ),
                        }}
                        sx={{ '& .MuiOutlinedInput-root': { pr: 1 } }}
                      />
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 4, lg: 1 }}>
                      <TextField
                        fullWidth
                        size="small"
                        label={denominationDiscount.discountType === "percentage" ? "Bank Disc. %" : "Bank Disc. €"}
                        id="discountBankTransfer"
                        placeholder="0"
                        type="number"
                        value={denominationDiscount.bankTransfer}
                        onChange={(e) => {
                          const raw = e.target.value;
                          if (raw !== '' && denominationDiscount.discountType === "percentage" && Number(raw) > 100) {
                            dispatch(showSnackbar({ message: "Discount cannot exceed 100%", severity: "error" }));
                            return;
                          }
                          setDenominationDiscount({
                            ...denominationDiscount,
                            bankTransfer: raw === '' ? '' : Number(raw),
                          });
                        }}
                        onInput={Utils.onlyPriceNumber}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {denominationDiscount.discountType === "percentage" ? "%" : "€"}
                            </InputAdornment>
                          ),
                        }}
                        sx={{ '& .MuiOutlinedInput-root': { pr: 1 } }}
                      />
                    </Grid2>
                  </>
                )}

                <Grid2 size={{ xs: 12, sm: 2, lg: 1 }}>
                  <Button
                    variant="contained"
                    onClick={() => {
                      const denomination: any = document.getElementById(
                        "denomination",
                      ) as HTMLInputElement;
                      const denominationDescription: any =
                        document.getElementById(
                          "denominationDescription",
                        ) as HTMLInputElement;
                      const productDenominationsku: any =
                        document.getElementById(
                          "productDenominationsku",
                        ) as HTMLInputElement;

                      let minValue: any = 0;
                      let maxValue: any = 0;
                      if (selectedOwnPriceTypeValue === "range") {
                        minValue = range.minValue;
                        maxValue = range.maxValue;
                      }
                      let object: Types.ITopupProductDenominationSKUModel = {
                        denomination: Number(denomination?.value || 0),
                        denominationDescription:
                          denominationDescription?.value || "",
                        denominationStatus: selectedDenominationValue as
                          | "active"
                          | "inactive",
                        type:
                          selectedOwnPriceTypeValue === "fixed"
                            ? "fixed"
                            : "range",
                        productDenominationsku: productDenominationsku?.value,
                        minValue: Number(minValue),
                        maxValue: Number(maxValue),
                        discount: {
                          discountType: denominationDiscount.discountType,
                          onlinePayment: Number(denominationDiscount.onlinePayment) || 0,
                          bankTransfer: Number(denominationDiscount.bankTransfer) || 0,
                        },
                      };
                      if (selectedOwnPriceTypeValue === "fixed") {
                        if (
                          !denomination?.value ||
                          denomination?.value.trim() == ""
                        ) {
                          setErrorMsg("Denomination is required");
                          return;
                        }
                      }

                      if (object.type === "range" && !object.minValue) {
                        setErrorMsg("Min Value is required");
                        return;
                      }

                      if (object.type === "range" && !object.maxValue) {
                        setErrorMsg("Max Value is required");
                        return;
                      }

                      if (
                        object.type === "range" &&
                        (!range.maxValue || range.maxValue == 0)
                      ) {
                        setErrorMsg("Max Value is required");
                        return;
                      }

                      if (
                        object.type === "range" &&
                        range.minValue >= range.maxValue
                      ) {
                        setErrorMsg("Min Value should be less than Max Value");
                        return;
                      }

                      if (
                        !productDenominationsku?.value ||
                        productDenominationsku?.value.trim() == ""
                      ) {
                        setErrorMsg("Denomination SKU is required");
                        return;
                      }

                      if (
                        !denominationDescription?.value ||
                        denominationDescription?.value.trim() == ""
                      ) {
                        setErrorMsg("Denomination Desciption is required");
                        return;
                      }
                      setErrorMsg("");
                      if (multiplePriceTempData.index !== -1) {
                        const isValid = handleUpdateFixedPrice(
                          object,
                          multiplePriceTempData.index,
                          multiplePriceTempData,
                        );
                        if (!isValid) {
                          return;
                        }
                        setSelectedDenominationValue("active");
                        if (selectedOwnPriceTypeValue === "fixed") {
                          denomination.value = "";
                        }
                      } else {
                        const isValid = handleAddFixedPrice(object);
                        if (!isValid) {
                          return;
                        }
                        setSelectedDenominationValue("active");
                        if (selectedOwnPriceTypeValue === "fixed") {
                          denomination.value = "";
                        }
                      }
                      denominationDescription.value = "";
                      productDenominationsku.value = "";
                      setRange({ minValue: 0, maxValue: 0 });
                      setSelectedOwnPriceTypeValue("fixed");
                      setMultiplePriceTempData({ index: -1 });
                      setDenominationDiscount({
                        discountType: 'percentage',
                        onlinePayment: 0,
                        bankTransfer: 0,
                      });
                    }}
                    fullWidth
                    sx={{ height: "95%" }}
                  >
                    {multiplePriceTempData.index === -1 ? "Add" : "Update"}
                  </Button>
                </Grid2>
              </Grid2>

              {errorMsg && (
                <Typography
                  color="error"
                  variant="caption"
                  sx={{ mt: 1, display: "block" }}
                >
                  {errorMsg}
                </Typography>
              )}

              <Box sx={{ mt: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
                <TableContainer component={Paper}>
                  <Table
                    sx={{ width: "100%" }}
                    size="small"
                    aria-label="a dense table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">#</TableCell>
                        <TableCell>Denominations</TableCell>
                        <TableCell align="left">SKU</TableCell>
                        <TableCell align="left">Description</TableCell>
                        <TableCell align="left">Type</TableCell>
                        <TableCell align="left">Status</TableCell>
                        {watch("discountApplyTo") === "per-denomination" && (
                          <>
                            <TableCell align="center">Online Discount</TableCell>
                            <TableCell align="center">Bank Discount</TableCell>
                          </>
                        )}
                        <TableCell align="left">Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {productDenominations &&
                      Array.isArray(productDenominations) &&
                      productDenominations.length > 0 &&
                      productDenominations[0]["productDenominationsku"]
                        ? productDenominations.map(
                            (row: any, index: number) => (
                              <TableRow
                                key={`pdenomination-${index}`}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell align="left">{index + 1}</TableCell>
                                <TableCell component="th" scope="row">
                                  {row.type === "fixed"
                                    ? `${Utils.formatEuro(row.denomination)}`
                                    : `${Utils.formatEuro(
                                        row.minValue,
                                      )} - ${Utils.formatEuro(row.maxValue)}`}
                                </TableCell>
                                <TableCell align="left">
                                  {row.productDenominationsku}
                                </TableCell>
                                <TableCell align="left">
                                  {row.denominationDescription}
                                </TableCell>
                                <TableCell align="left">
                                  {row.type === "fixed" ? "Fixed" : "Range"}
                                </TableCell>
                                <TableCell align="left">
                                  {row.denominationStatus === "active"
                                    ? "Active"
                                    : "Inactive"}
                                </TableCell>
                                {watch("discountApplyTo") === "per-denomination" && (
                                  <>
                                    <TableCell align="center">
                                      {row.discount?.onlinePayment || 0}
                                      {row.discount?.discountType === "percentage" ? "%" : "€"}
                                    </TableCell>
                                    <TableCell align="center">
                                      {row.discount?.bankTransfer || 0}
                                      {row.discount?.discountType === "percentage" ? "%" : "€"}
                                    </TableCell>
                                  </>
                                )}
                                <TableCell align="left">
                                  <IconButton
                                    color="error"
                                    onClick={() => {
                                      handleEditFixedPrice(row, index);
                                    }}
                                  >
                                    <FaPencil size={10} />
                                  </IconButton>

                                  <IconButton
                                    color="error"
                                    onClick={() => {
                                      handleRemoveFixedPrice(row);
                                    }}
                                  >
                                    <FaTrash size={10} />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            ),
                          )
                        : null}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* {productDenominations.map((item, index) => (
                      <Chip
                        key={index}
                        label={`${item.productDenominationsku}`}
                        onDelete={() => handleRemoveFixedPrice(item)}
                        sx={{
                          '& .MuiChip-deleteIcon': {
                            color: 'error.main',
                            ':hover': {
                              color: 'error.dark'
                            }
                          }
                        }}
                      />
                    ))} */}
              </Box>

              <div style={{ marginTop: "25px" }}></div>
              <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, sm: 4, lg: 4 }}>
                  <Controller
                    name="pinQr"
                    control={control}
                    rules={{}}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        size="small"
                        label="Pin QR"
                        placeholder="Enter Pin Qr"
                        type="text"
                        id="pinQr"
                        error={!!errors.pinQr}
                        helperText={errors.pinQr?.message}
                      />
                    )}
                  />
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 4, lg: 4 }}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Max Order Qty"
                    placeholder="Enter Max Order Qty"
                    type="number"
                    id="maxOrderQty"
                    {...register("maxOrderQty")}
                    error={!!errors.maxOrderQty}
                    helperText={errors.maxOrderQty?.message}
                    onWheel={(e) => (e.target as HTMLInputElement).blur()}
                  />
                </Grid2>
              </Grid2>
            </Box>

            {/* <FormControlLabel
                control={<Checkbox />}
                label="Charge tax on this product"
                sx={{ mt: 2 }}
              /> */}
          </Paper>

          <Grid2 container spacing={2}>
            <Grid2 size={{ xs: 12, md: 12, lg: 6, xl: 6 }}>
              {/* Teams and  term Link Listing */}
              <Paper sx={{ px: 2, pb: 2, pt: 1.5, mb: 2 }}>
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 1, position: "relative" }}
                >
                  Terms and Conditions<em className="imp">*</em>
                </Typography>
                {isFormReady ? (
                  <Box
                    onClick={() => {
                      // Focus the Quill editor when clicking anywhere in the container
                      if (termsQuillRef.current) {
                        const quill = (
                          termsQuillRef.current as any
                        ).getEditor?.();
                        if (quill) {
                          quill.focus();
                        }
                      }
                    }}
                    sx={{
                      "& .quill": {
                        borderRadius: 1,
                        "& .ql-toolbar": {
                          borderTopLeftRadius: 1,
                          borderTopRightRadius: 1,
                          backgroundColor: alpha(
                            theme.palette.primary.main,
                            0.03,
                          ),
                        },
                        "& .ql-container": {
                          borderBottomLeftRadius: 1,
                          borderBottomRightRadius: 1,
                          minHeight: "200px",
                          cursor: "text",
                        },
                      },
                    }}
                  >
                    <Controller
                      name="terms"
                      control={control}
                      rules={{
                        required: "Terms and conditions is required",
                        validate: (value) => {
                          if (
                            value.replace(/<(.|\n)*?>/g, "").trim().length === 0
                          ) {
                            return "Terms and conditions cannot be empty";
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <>
                          <ReactQuill
                            theme="snow"
                            ref={(el) => {
                              termsQuillRef.current = el;
                              if (typeof field.ref === "function") {
                                field.ref(el);
                              }

                              // Set up keyboard bindings after the editor is mounted
                              if (el) {
                                const quill = (el as any).getEditor?.();
                                if (quill) {
                                  const keyboard = quill.getModule("keyboard");

                                  // Prevent space at the start
                                  keyboard.addBinding({
                                    key: " ",
                                    handler: function (range: any) {
                                      const text = quill.getText();
                                      const textBeforeCursor = text.slice(
                                        0,
                                        range.index,
                                      );

                                      // Allow space if there's non-whitespace content before cursor
                                      if (
                                        range.index === 0 ||
                                        /^[\s\n]*$/.test(textBeforeCursor)
                                      ) {
                                        return false; // Prevent the space
                                      }
                                      return true; // Allow the space
                                    },
                                  });

                                  // Prevent tab at the start
                                  keyboard.addBinding({
                                    key: 9, // Tab key code
                                    handler: function (range: any) {
                                      const text = quill.getText();
                                      const textBeforeCursor = text.slice(
                                        0,
                                        range.index,
                                      );

                                      // Allow tab if there's non-whitespace content before cursor
                                      if (
                                        range.index === 0 ||
                                        /^[\s\n]*$/.test(textBeforeCursor)
                                      ) {
                                        return false; // Prevent the tab
                                      }
                                      return true; // Allow the tab
                                    },
                                  });
                                }
                              }
                            }}
                            value={field.value}
                            onChange={field.onChange}
                            placeholder={"Enter Terms and conditions"}
                            modules={{
                              toolbar: [
                                [{ header: [1, 2, 3, false] }],
                                ["bold", "italic", "underline", "strike"],
                                [{ list: "ordered" }, { list: "bullet" }],
                                ["link", "image"],
                                ["clean"],
                              ],
                            }}
                          />
                          {errors.terms && (
                            <Typography
                              color="error"
                              variant="caption"
                              sx={{ mt: 0.5, display: "block" }}
                            >
                              {errors.terms.message}
                            </Typography>
                          )}
                        </>
                      )}
                    />
                  </Box>
                ) : (
                  <Skeleton variant="rectangular" width={"100%"} height={200} />
                )}

                <Box sx={{ mt: 2.5 }}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Terms and conditions link<em className="opt">(optional)</em>
                  </Typography>
                  <Controller
                    name="termsLink"
                    control={control}
                    rules={{}}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        size="small"
                        label="Terms and conditions link"
                        error={!!errors.termsLink}
                        placeholder="Enter Terms and conditions link"
                      />
                    )}
                  />
                </Box>
              </Paper>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 12, lg: 6, xl: 6 }}>
              {/* How to Redeem */}
              <Paper sx={{ px: 2, pb: 2, pt: 1.5, mb: 2 }}>
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 1, position: "relative" }}
                >
                  How to Redeem<em className="imp">*</em>
                </Typography>
                {isFormReady ? (
                  <Box
                    onClick={() => {
                      // Focus the Quill editor when clicking anywhere in the container
                      if (instructionsQuillRef.current) {
                        const quill = (
                          instructionsQuillRef.current as any
                        ).getEditor?.();
                        if (quill) {
                          quill.focus();
                        }
                      }
                    }}
                    sx={{
                      "& .quill": {
                        borderRadius: 1,
                        "& .ql-toolbar": {
                          borderTopLeftRadius: 1,
                          borderTopRightRadius: 1,
                          backgroundColor: alpha(
                            theme.palette.primary.main,
                            0.03,
                          ),
                        },
                        "& .ql-container": {
                          borderBottomLeftRadius: 1,
                          borderBottomRightRadius: 1,
                          minHeight: "200px",
                          cursor: "text",
                        },
                      },
                    }}
                  >
                    <Controller
                      name="instructions"
                      control={control}
                      rules={{
                        required: "Redemption instructions are required",
                        validate: (value) => {
                          if (
                            value.replace(/<(.|\n)*?>/g, "").trim().length === 0
                          ) {
                            return "Instructions cannot be empty";
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <>
                          <ReactQuill
                            theme="snow"
                            ref={(el) => {
                              instructionsQuillRef.current = el;
                              if (typeof field.ref === "function") {
                                field.ref(el);
                              }

                              // Set up keyboard bindings after the editor is mounted
                              if (el) {
                                const quill = (el as any).getEditor?.();
                                if (quill) {
                                  const keyboard = quill.getModule("keyboard");

                                  // Prevent space at the start
                                  keyboard.addBinding({
                                    key: " ",
                                    handler: function (range: any) {
                                      const text = quill.getText();
                                      const textBeforeCursor = text.slice(
                                        0,
                                        range.index,
                                      );

                                      // Allow space if there's non-whitespace content before cursor
                                      if (
                                        range.index === 0 ||
                                        /^[\s\n]*$/.test(textBeforeCursor)
                                      ) {
                                        return false; // Prevent the space
                                      }
                                      return true; // Allow the space
                                    },
                                  });

                                  // Prevent tab at the start
                                  keyboard.addBinding({
                                    key: 9, // Tab key code
                                    handler: function (range: any) {
                                      const text = quill.getText();
                                      const textBeforeCursor = text.slice(
                                        0,
                                        range.index,
                                      );

                                      // Allow tab if there's non-whitespace content before cursor
                                      if (
                                        range.index === 0 ||
                                        /^[\s\n]*$/.test(textBeforeCursor)
                                      ) {
                                        return false; // Prevent the tab
                                      }
                                      return true; // Allow the tab
                                    },
                                  });
                                }
                              }
                            }}
                            value={field.value}
                            onChange={field.onChange}
                            placeholder={"Enter redemption instructions"}
                            modules={{
                              toolbar: [
                                [{ header: [1, 2, 3, false] }],
                                ["bold", "italic", "underline", "strike"],
                                [{ list: "ordered" }, { list: "bullet" }],
                                ["link", "image"],
                                ["clean"],
                              ],
                            }}
                          />
                          {errors.instructions && (
                            <Typography
                              color="error"
                              variant="caption"
                              sx={{ mt: 0.5, display: "block" }}
                            >
                              {errors.instructions.message}
                            </Typography>
                          )}
                        </>
                      )}
                    />
                  </Box>
                ) : (
                  <Skeleton variant="rectangular" width={"100%"} height={200} />
                )}
              </Paper>
            </Grid2>
          </Grid2>
        </Box>

        <Box>
          <Grid2 container spacing={2}>
            {/* Taxation */}
            <Grid2 size={{ xs: 12, md: 12, lg: 6, xl: 6 }}>
              <Paper sx={{ p: 2 }}>
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 1, position: "relative" }}
                >
                  Taxation
                </Typography>

                <Box sx={{ display: "flex", gap: 2 }}>
                  {/* Inclusive of Tax Dropdown */}
                  <FormControl
                    fullWidth
                    size="small"
                    error={!!errors.isInclusiveOfTax}
                  >
                    <InputLabel>Inclusive of Tax*</InputLabel>
                    <Controller
                      name="isInclusiveOfTax"
                      control={control}
                      rules={{ required: "This field is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          label="Inclusive of Tax*"
                          value={field.value?.toString() || ""}
                          onChange={(e) =>
                            field.onChange(e.target.value === "true")
                          }
                          error={!!errors.isInclusiveOfTax}
                        >
                          <MenuItem value="true">True</MenuItem>
                          <MenuItem value="false">False</MenuItem>
                        </Select>
                      )}
                    />
                    {errors.isInclusiveOfTax && (
                      <FormHelperText>
                        {errors.isInclusiveOfTax.message}
                      </FormHelperText>
                    )}
                  </FormControl>

                  {/* Taxation Profile Dropdown */}
                  <FormControl
                    id="taxProfileId"
                    fullWidth
                    size="small"
                    error={!!errors.taxProfileId || !!taxCoverageError}
                  >
                    <InputLabel>Taxation Profile</InputLabel>
                    <Controller
                      name="taxProfileId"
                      control={control}
                      rules={{ required: "Taxation profile is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          label="Taxation Profile"
                          error={!!errors.taxProfileId}
                          MenuProps={{
                            PaperProps: {
                              onScroll: handleTaxProfilesScroll,
                              style: { maxHeight: 300 },
                              ref: taxMenuRef,
                            },
                            disableAutoFocusItem: true,
                          }}
                        >
                          {/* Search field */}
                          {/* <Box sx={{ p: 1, borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
                            <TextField
                              fullWidth
                              size="small"
                              placeholder="Search tax profiles..."
                              value={taxSearch}
                              onChange={(e) => setTaxSearch(e.target.value)}
                              onClick={(e) => e.stopPropagation()}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <SearchIcon fontSize="small" />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Box> */}

                          {/*
                            Refresh, inside the menu where the gap is noticed.

                            Placed as a menu row rather than an icon beside the
                            field so it is found at the moment somebody opens
                            the list and cannot see the profile they just
                            created. onMouseDown, because MUI closes the menu
                            on click and the reload would be cancelled.
                          */}
                          <Box
                            onMouseDown={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              reloadTaxProfiles();
                            }}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              px: 2,
                              py: 1,
                              cursor: "pointer",
                              color: "primary.main",
                              borderBottom: "1px solid rgba(0,0,0,0.12)",
                              "&:hover": { backgroundColor: "action.hover" },
                            }}
                          >
                            <Typography variant="body2">
                              {isTaxFetching
                                ? "Refreshing…"
                                : "Refresh list"}
                            </Typography>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              added a profile just now?
                            </Typography>
                          </Box>

                          {/* Tax profiles list */}
                          {taxProfiles.map((profile: any) => (
                            <MenuItem key={profile._id} value={profile._id}>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                width="100%"
                              >
                                <Typography
                                  variant="body2"
                                  color="text.primary"
                                >
                                  {profile.profileName}
                                </Typography>
                                <Box
                                  sx={{
                                    height: "16px",
                                    width: "1px",
                                    backgroundColor: "primary.main",
                                    mx: 1,
                                  }}
                                />
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  {profile.profileCode}
                                </Typography>
                              </Box>
                            </MenuItem>
                          ))}

                          {/* Loading indicator */}
                          {(isLoadingMore || isTaxFetching) && (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                p: 2,
                              }}
                            >
                              <CircularProgress size={24} />
                            </Box>
                          )}

                          {/* No more results */}
                          {!isLoadingMore && taxProfiles.length === 0 && (
                            <MenuItem
                              disabled
                              sx={{ justifyContent: "center" }}
                            >
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                No tax profiles found
                              </Typography>
                            </MenuItem>
                          )}
                        </Select>
                      )}
                    />
                    {errors.taxProfileId && (
                      <FormHelperText>
                        {errors.taxProfileId.message}
                      </FormHelperText>
                    )}
                    {!errors.taxProfileId && taxCoverageError && (
                      <FormHelperText>{taxCoverageError}</FormHelperText>
                    )}
                  </FormControl>
                </Box>
              </Paper>
            </Grid2>
          </Grid2>
        </Box>

        {/* Footer Actions */}
        <Box sx={{ mt: 3, display: "flex", justifyContent: "center", gap: 2 }}>
          {/* <div className="text-red-500 mt-4">
           {JSON.stringify(errors)}
          </div> */}
        </Box>
        <Box
          sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 2 }}
        >
          <Button variant="outlined" color="error" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            onClick={() => checkManualyDenomination(true)}
            disabled={
              isCheckingDuplicate || isLoading
              //  ||
              // selectedCurrency.allValidCurrencies === false
              //   ? true
              //   : false || isDuplicateIssue
            }
          >
            {isLoading || isCheckingDuplicate ? (
              <CircularProgress size={24} />
            ) : id ? (
              "Update Product"
            ) : (
              "Create Product"
            )}
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default AddProduct;
